export const tags = [
  { value: "Crops", name: "#Crops" },
  { value: "Wheat", name: "#Wheat" },
  { value: "Rice", name: "#Rice" },
  { value: "Edible-Oils", name: "#Edible-Oils" },
  { value: "Sugarcane", name: "#Sugarcane" },
  { value: "Cotton", name: "#Cotton" },
  { value: "Barley", name: "#Barley" },
  { value: "Maize", name: "#Maize" },
  { value: "Corn", name: "#Corn" },
  { value: "CropReports", name: "#CropReports" },
  { value: "WheatHarvest", name: "#WheatHarvest" },
  { value: "WheatSowing", name: "#WheatSowing" },
  { value: "WheatCultivation", name: "#WheatCultivation" },
  { value: "CottonIntention", name: "#CottonIntention" },
  { value: "CottonHarvest", name: "#CottonHarvest" },
  { value: "CottonSowing", name: "#CottonSowing" },
  { value: "CottonCultivation", name: "#CottonCultivation" },
  { value: "SugarcaneHarvest", name: "#SugarcaneHarvest" },
  { value: "SugarcaneSowing", name: "#SugarcaneSowing" },
  { value: "SugarcaneCultivation", name: "#SugarcaneCultivation" },
  { value: "SugarcaneFarming", name: "#SugarcaneFarming" },
  { value: "SugarIndustry", name: "#SugarIndustry" },
  { value: "MaizeHarvest", name: "#MaizeHarvest" },
  { value: "MaizeSowing", name: "#MaizeSowing" },
  { value: "MaizeCultivation", name: "#MaizeCultivation" },
  { value: "CornCultivation", name: "#CornCultivation" },
  { value: "MilletCrops", name: "#MilletCrops" },
  { value: "Sorghum", name: "#Sorghum" },
  { value: "Barley", name: "#Barley" },
  { value: "Fruits", name: "#Fruits" },
  { value: "Mangoes", name: "#Mangoes" },
  { value: "Citrus", name: "#Citrus" },
  { value: "Apples", name: "#Apples" },
  { value: "FruitFarming", name: "#FruitFarming" },
  { value: "Vegetables", name: "#Vegetables" },
  { value: "Potatoes", name: "#Potatoes" },
  { value: "Onions", name: "#Onions" },
  { value: "Tomatoes", name: "#Tomatoes" },
  { value: "VegetableCultivation", name: "#VegetableCultivation" },
  { value: "Pulses", name: "#Pulses" },
  { value: "Lentils", name: "#Lentils" },
  { value: "Masoor", name: "#Masoor" },
  { value: "MasoorDal", name: "#MasoorDal" },
  { value: "Chickpeas", name: "#Chickpeas" },
  { value: "Chana", name: "#Chana" },
  { value: "BlackGram", name: "#BlackGram" },
  { value: "Urad", name: "#Urad" },
  { value: "YellowMoongLentils", name: "#YellowMoongLentils" },
  { value: "MoongDal", name: "#MoongDal" },
  { value: "WhiteChickpeas", name: "#WhiteChickpeas" },
  { value: "SafaidChana", name: "#SafaidChana" },
  { value: "BlackLentils", name: "#BlackLentils" },
  { value: "SabutMasoor", name: "#SabutMasoor" },
  { value: "PigeonPeas", name: "#PigeonPeas" },
  { value: "Toor", name: "#Toor" },
  { value: "Arhar", name: "#Arhar" },
  { value: "GreenMoongLentils", name: "#GreenMoongLentils" },
  { value: "SabutMoong", name: "#SabutMoong" },
  { value: "Cowpeas", name: "#Cowpeas" },
  { value: "Chawli", name: "#Chawli" },
  { value: "GreenGram", name: "#GreenGram" },
  { value: "Moong", name: "#Moong" },
  { value: "Peas", name: "#Peas" },
  { value: "Matar", name: "#Matar" },
  { value: "BroadBeans", name: "#BroadBeans" },
  { value: "Sem", name: "#Sem" },
  { value: "Lobia", name: "#Lobia" },
  { value: "BlackEyedPeas", name: "#BlackEyedPeas" },
  { value: "MungBeans", name: "#MungBeans" },
  { value: "Oilseeds", name: "#Oilseeds" },
  { value: "Canola", name: "#Canola" },
  { value: "Sunflower", name: "#Sunflower" },
  { value: "Tobacco", name: "#Tobacco" },
  { value: "Cigarettes", name: "#Cigarettes" },
  { value: "TobaccoExport", name: "#TobaccoExport" },
  { value: "TobaccoImport", name: "#TobaccoImport" },
  { value: "TextileSector", name: "#TextileSector" },
  { value: "AgroTextiles", name: "#AgroTextiles" },
  { value: "FiberFarming", name: "#FiberFarming" },
  { value: "CottonHarvest", name: "#CottonHarvest" },
  { value: "TextileCrops", name: "#TextileCrops" },
  { value: "SustainableFibers", name: "#SustainableFibers" },
  { value: "TextileAgriculture", name: "#TextileAgriculture" },
  { value: "LinenFarming", name: "#LinenFarming" },
  { value: "SilkProduction", name: "#SilkProduction" },
  { value: "JuteCultivation", name: "#JuteCultivation" },
  { value: "WoolHarvest", name: "#WoolHarvest" },
  { value: "NaturalFibers", name: "#NaturalFibers" },
  { value: "TextileCotton", name: "#TextileCotton" },
  { value: "FiberCrops", name: "#FiberCrops" },
  { value: "AgroFabric", name: "#AgroFabric" },
  { value: "TextileFarming", name: "#TextileFarming" },
  { value: "OrganicTextiles", name: "#OrganicTextiles" },
  { value: "AgriculturalFibers", name: "#AgriculturalFibers" },
  { value: "FiberHarvest", name: "#FiberHarvest" },
  { value: "CottonFarming", name: "#CottonFarming" },
  { value: "EcoTextiles", name: "#EcoTextiles" },
  { value: "AgroFiber", name: "#AgroFiber" },
  { value: "SustainableTextiles", name: "#SustainableTextiles" },
  { value: "NaturalFiberCrops", name: "#NaturalFiberCrops" },
  { value: "AgroWool", name: "#AgroWool" },
  { value: "TextileSustainability", name: "#TextileSustainability" },
  { value: "HempFarming", name: "#HempFarming" },
  { value: "AgriculturalTextiles", name: "#AgriculturalTextiles" },
  { value: "BambooFiber", name: "#BambooFiber" },
  { value: "TextileAgroEconomy", name: "#TextileAgroEconomy" },
  { value: "AgroCloth", name: "#AgroCloth" },
  { value: "SustainableFarming", name: "#SustainableFarming" },
  { value: "TextileAgroIndustry", name: "#TextileAgroIndustry" },
  { value: "OrganicCotton", name: "#OrganicCotton" },
  { value: "TextileCultivation", name: "#TextileCultivation" },
  { value: "AgronomyTextiles", name: "#AgronomyTextiles" },
  { value: "TextileAgroBusiness", name: "#TextileAgroBusiness" },
  { value: "AgroSisal", name: "#AgroSisal" },
  { value: "FarmingTextiles", name: "#FarmingTextiles" },
  { value: "AgriculturalFiberCrops", name: "#AgriculturalFiberCrops" },
  { value: "CottonSustainability", name: "#CottonSustainability" },
  { value: "TextileAgroInnovation", name: "#TextileAgroInnovation" },
  { value: "AgroTextileProducts", name: "#AgroTextileProducts" },
  { value: "FarmToFabric", name: "#FarmToFabric" },
  { value: "TextileAgroTech", name: "#TextileAgroTech" },
  {
    value: "AgriculturalTextileProducts",
    name: "#AgriculturalTextileProducts",
  },
  { value: "TextileAgroEcoSystem", name: "#TextileAgroEcoSystem" },
  { value: "HempHarvest", name: "#HempHarvest" },
  { value: "BambooTextiles", name: "#BambooTextiles" },
  { value: "SustainableJute", name: "#SustainableJute" },
  { value: "JuteHarvesting", name: "#JuteHarvesting" },
  { value: "AgrifiberInnovation", name: "#AgrifiberInnovation" },
  { value: "SustainableSilk", name: "#SustainableSilk" },
  { value: "SilkFarming", name: "#SilkFarming" },
  { value: "NaturalFiberProduction", name: "#NaturalFiberProduction" },
  { value: "TextileAgroSolutions", name: "#TextileAgroSolutions" },
  { value: "AgroFabricIndustry", name: "#AgroFabricIndustry" },
  {
    value: "CottonSustainableAgriculture",
    name: "#CottonSustainableAgriculture",
  },
  { value: "AgroTextileTrade", name: "#AgroTextileTrade" },
  { value: "EcoTextileFarming", name: "#EcoTextileFarming" },
  { value: "AgroTextileSustainability", name: "#AgroTextileSustainability" },
  { value: "RegenerativeTextiles", name: "#RegenerativeTextiles" },
  { value: "Spices", name: "#Spices" },
  { value: "Cumin", name: "#Cumin" },
  { value: "Zeera", name: "#Zeera" },
  { value: "Coriander", name: "#Coriander" },
  { value: "Dhania", name: "#Dhania" },
  { value: "Turmeric", name: "#Turmeric" },
  { value: "Haldi", name: "#Haldi" },
  { value: "RedChiliPowder", name: "#RedChiliPowder" },
  { value: "LalMirch", name: "#LalMirch" },
  { value: "GaramMasala", name: "#GaramMasala" },
  { value: "MustardSeeds", name: "#MustardSeeds" },
  { value: "Sarson", name: "#Sarson" },
  { value: "FenugreekSeeds", name: "#FenugreekSeeds" },
  { value: "Methi", name: "#Methi" },
  { value: "NigellaSeeds", name: "#NigellaSeeds" },
  { value: "Kalonji", name: "#Kalonji" },
  { value: "Cardamon", name: "#Cardamon" },
  { value: "Elaichi", name: "#Elaichi" },
  { value: "Cloves", name: "#Cloves" },
  { value: "Laung", name: "#Laung" },
  { value: "Cinnamon", name: "#Cinnamon" },
  { value: "Dalchini", name: "#Dalchini" },
  { value: "BayLeaves", name: "#BayLeaves" },
  { value: "TezPatta", name: "#TezPatta" },
  { value: "BlackPepper", name: "#BlackPepper" },
  { value: "KaliMirch", name: "#KaliMirch" },
  { value: "FennelSeeds", name: "#FennelSeeds" },
  { value: "Saunf", name: "#Saunf" },
  { value: "Asafoetida", name: "#Asafoetida" },
  { value: "Hing", name: "#Hing" },
  { value: "DriedMangoPowder", name: "#DriedMangoPowder" },
  { value: "Amchur", name: "#Amchur" },
  { value: "CaromSeeds", name: "#CaromSeeds" },
  { value: "Ajwain", name: "#Ajwain" },
  { value: "Paprika", name: "#Paprika" },
  { value: "PoppySeeds", name: "#PoppySeeds" },
  { value: "KhusKhus", name: "#KhusKhus" },
  { value: "TurmericLeaves", name: "#TurmericLeaves" },
  { value: "HaldiPatta", name: "#HaldiPatta" },
  { value: "Chillies", name: "#Chillies" },
  { value: "Peppers", name: "#Peppers" },
  { value: "DryFruits", name: "#DryFruits" },
  { value: "Almonds", name: "#Almonds" },
  { value: "Badam", name: "#Badam" },
  { value: "WallNuts", name: "#WallNuts" },
  { value: "Akhrot", name: "#Akhrot" },
  { value: "Pistachios", name: "#Pistachios" },
  { value: "Pista", name: "#Pista" },
  { value: "DriedApricots", name: "#DriedApricots" },
  { value: "Khubani", name: "#Khubani" },
  { value: "DriedFigs", name: "#DriedFigs" },
  { value: "Anjeer", name: "#Anjeer" },
  { value: "Raisins", name: "#Raisins" },
  { value: "Kishmish", name: "#Kishmish" },
  { value: "Dates", name: "#Dates" },
  { value: "Khajoor", name: "#Khajoor" },
  { value: "DriedPlums", name: "#DriedPlums" },
  { value: "AlooBukhara", name: "#AlooBukhara" },
  { value: "Cashews", name: "#Cashews" },
  { value: "Kaju", name: "#Kaju" },
  { value: "DriedPomegranateSeeds", name: "#DriedPomegranateSeeds" },
  { value: "Anardana", name: "#Anardana" },
  { value: "DriedMulberries", name: "#DriedMulberries" },
  { value: "Shahtoot", name: "#Shahtoot" },
  { value: "DriedPineapple", name: "#DriedPineapple" },
  { value: "DriedMango", name: "#DriedMango" },
  { value: "Amchur", name: "#Amchur" },
  { value: "Chilgoza", name: "#Chilgoza" },
  { value: "PineNuts", name: "#PineNuts" },
  { value: "DriedCranberries", name: "#DriedCranberries" },
  { value: "DriedKiwi", name: "#DriedKiwi" },
  { value: "DriedBlueberries", name: "#DriedBlueberries" },
  { value: "DriedPapaya", name: "#DriedPapaya" },
  { value: "PAR", name: "#PAR" },
  { value: "PakistanAgriculture", name: "#PakistanAgriculture" },
  { value: "PARNewsBulletin", name: "#PARNewsBulletin" },
  { value: "PARNews", name: "#PARNews" },
  { value: "AgriNewsPK", name: "#AgriNewsPK" },
  { value: "AgriculturalUpdates", name: "#AgriculturalUpdates" },
  { value: "FarmingInPakistan", name: "#FarmingInPakistan" },
  { value: "Agribusiness", name: "#Agribusiness" },
  { value: "RuralDevelopment", name: "#RuralDevelopment" },
  { value: "AgricultureTechPK", name: "#AgricultureTechPK" },
  { value: "FarmersLife", name: "#FarmersLife" },
  { value: "Agronomy", name: "#Agronomy" },
  { value: "HarvestSeason", name: "#HarvestSeason" },
  { value: "CropManagement", name: "#CropManagement" },
  { value: "GreenRevolutionPK", name: "#GreenRevolutionPK" },
  { value: "SustainableFarming", name: "#SustainableFarming" },
  { value: "FarmLife", name: "#FarmLife" },
  { value: "AgriculturalPolicy", name: "#AgriculturalPolicy" },
  { value: "FoodSecurity", name: "#FoodSecurity" },
  { value: "CropDiversity", name: "#CropDiversity" },
  { value: "Agronomy", name: "#Agronomy" },
  { value: "SoilHealth", name: "#SoilHealth" },
  { value: "ClimateSmartAgri", name: "#ClimateSmartAgri" },
  { value: "PrecisionFarming", name: "#PrecisionFarming" },
  { value: "FarmersMarketPK", name: "#FarmersMarketPK" },
  { value: "CropInsurance", name: "#CropInsurance" },
  { value: "AgroInnovation", name: "#AgroInnovation" },
  { value: "RuralLivelihoods", name: "#RuralLivelihoods" },
  { value: "AgroTrade", name: "#AgroTrade" },
  { value: "AgricultureEducation", name: "#AgricultureEducation" },
  { value: "ModernFarming", name: "#ModernFarming" },
  { value: "WaterManagement", name: "#WaterManagement" },
  { value: "AgroTech", name: "#AgroTech" },
  { value: "OrganicFarmingPK", name: "#OrganicFarmingPK" },
  { value: "LivestockFarming", name: "#LivestockFarming" },
  { value: "AgriculturalResearch", name: "#AgriculturalResearch" },
  { value: "FarmersNetwork", name: "#FarmersNetwork" },
  { value: "AgroInvestment", name: "#AgroInvestment" },
  { value: "AgroExports", name: "#AgroExports" },
  { value: "HarvestTime", name: "#HarvestTime" },
  { value: "FarmersSupport", name: "#FarmersSupport" },
  { value: "FoodProduction", name: "#FoodProduction" },
];

export const category = [
  { value: "Economics & Finance", name: "Economics & Finance" },
  { value: "Business & Industry", name: "Business & Industry" },
  { value: "Politics & Governance", name: "Politics & Governance" },
  { value: "International Affairs", name: "International Affairs" },
  { value: "Infrastructure & Energy", name: "Infrastructure & Energy" },
  { value: "Opinions & Analysis", name: "Opinions & Analysis" },
];
export const productOptions = [
  { value: "1", text: "Cotton" },
  { value: "2", text: "Sugarcane" },
  { value: "3", text: "Wheat" },
  { value: "4", text: "Rice" },
  { value: "5", text: "Corn" },
  { value: "8", text: "Pulses" },
  { value: "9", text: "Edible-Oil" },
  { value: "10", text: "Spices" },
  { value: "11", text: "Wheat" },
  { value: "12", text: "Rice" },
  { value: "13", text: "Maize" },
  { value: "14", text: "Barley" },
  { value: "15", text: "Oats" },
  { value: "16", text: "Millet" },
  { value: "17", text: "Sorghum" },
  { value: "18", text: "Chickpea" },
  { value: "19", text: "Lentil" },
  { value: "20", text: "Black gram" },
  { value: "21", text: "Kidney bean" },
  { value: "22", text: "Mung bean" },
  { value: "23", text: "Soybean" },
  { value: "24", text: "Potato" },
  { value: "25", text: "Tomato" },
  { value: "26", text: "Onion" },
  { value: "27", text: "Pea" },
  { value: "28", text: "Cucumber" },
  { value: "29", text: "Carrot" },
  { value: "30", text: "Okra" },
  { value: "31", text: "Eggplant" },
  { value: "32", text: "Bell pepper" },
  { value: "33", text: "Mango" },
  { value: "34", text: "Banana" },
  { value: "35", text: "Apple" },
  { value: "36", text: "Orange" },
  { value: "37", text: "Watermelon" },
  { value: "38", text: "Grapes" },
  { value: "39", text: "Strawberry" },
  { value: "40", text: "Pineapple" },
  { value: "41", text: "Cotton" },
  { value: "42", text: "Sugarcane" },
  { value: "43", text: "Tobacco" },
  { value: "44", text: "Jute" },
  { value: "45", text: "Tea" },
  { value: "46", text: "Coffee" },
  { value: "47", text: "Sunflower" },
  { value: "48", text: "Canola" },
  { value: "49", text: "Cottonseed" },
  { value: "50", text: "Mustard" },
  { value: "51", text: "Sesame" },
  { value: "52", text: "Vegetable" },
];

export const districts = [
  { district_id: "1", district: "Abbottabad" },
  { district_id: "2", district: "Attock" },
  { district_id: "3", district: "Awaran" },
  { district_id: "4", district: "Badin" },
  { district_id: "5", district: "Bahawalnagar" },
  { district_id: "6", district: "Bahawalpur" },
  { district_id: "7", district: "Bajaur Agency" },
  { district_id: "8", district: "Bannu" },
  { district_id: "9", district: "Barkhan" },
  { district_id: "10", district: "Batgram" },
  { district_id: "11", district: "Bhakkar" },
  { district_id: "12", district: "Bolan (Dhadar)" },
  { district_id: "13", district: "Bunner" },
  { district_id: "14", district: "Chagai" },
  { district_id: "15", district: "Chakwal" },
  { district_id: "16", district: "Charsadda" },
  { district_id: "17", district: "Chiniot" },
  { district_id: "18", district: "Chitral" },
  { district_id: "19", district: "Dadu" },
  { district_id: "20", district: "Dera Bughti" },
  { district_id: "21", district: "Dera Ghazi Khan" },
  { district_id: "22", district: "Dera Ismail Khan" },
  { district_id: "23", district: "Faisalabad" },
  { district_id: "24", district: "Ghotki" },
  { district_id: "25", district: "Gujranwala" },
  { district_id: "26", district: "Gujrat" },
  { district_id: "27", district: "Gwadar" },
  { district_id: "28", district: "Hafizabad" },
  { district_id: "29", district: "Hangu" },
  { district_id: "30", district: "Haripur" },
  { district_id: "31", district: "Harnai" },
  { district_id: "32", district: "Hyderabad" },
  { district_id: "33", district: "Islamabad" },
  { district_id: "34", district: "Jacobabad" },
  { district_id: "35", district: "Jaffarabad" },
  { district_id: "36", district: "Jamshoro" },
  { district_id: "37", district: "Jhal Magsi" },
  { district_id: "38", district: "Jhang" },
  { district_id: "39", district: "Jhelum" },
  { district_id: "40", district: "Kalat" },
  { district_id: "41", district: "Karachi" },
  { district_id: "42", district: "Karak" },
  { district_id: "43", district: "Kasur" },
  { district_id: "44", district: "Kech(Turbat)" },
  { district_id: "45", district: "Khairpur" },
  { district_id: "46", district: "Khanewal" },
  { district_id: "47", district: "Kharan" },
  { district_id: "48", district: "Khushab" },
  { district_id: "49", district: "Khuzdar" },
  { district_id: "50", district: "Khyber Agency" },
  { district_id: "51", district: "Killa Abdullah" },
  { district_id: "52", district: "Killa Saifullah" },
  { district_id: "53", district: "Kohat" },
  { district_id: "54", district: "Kohistan" },
  { district_id: "55", district: "Kohlu" },
  { district_id: "56", district: "Kurram Agency" },
  { district_id: "57", district: "Lahore City" },
  { district_id: "58", district: "Lakki Marwat" },
  { district_id: "59", district: "Larkana" },
  { district_id: "60", district: "Lasbella" },
  { district_id: "61", district: "Layyah" },
  { district_id: "62", district: "Lodhran" },
  { district_id: "63", district: "Loralai" },
  { district_id: "64", district: "Lower Dir" },
  { district_id: "65", district: "Malakand" },
  { district_id: "66", district: "Mandi Bahauddin" },
  { district_id: "67", district: "Mansehra" },
  { district_id: "68", district: "Mardan" },
  { district_id: "69", district: "Mastung" },
  { district_id: "70", district: "Matiari" },
  { district_id: "71", district: "Mianwali" },
  { district_id: "72", district: "Mirpur Khas" },
  { district_id: "73", district: "Mohmand Agency" },
  { district_id: "74", district: "Multan" },
  { district_id: "75", district: "Musakhel" },
  { district_id: "76", district: "Muzaffargarh" },
  { district_id: "77", district: "Narowal" },
  { district_id: "78", district: "Nasirabad" },
  { district_id: "79", district: "Naushro Feroze" },
  { district_id: "80", district: "Nawabshah" },
  { district_id: "81", district: "New Mirpur" },
  { district_id: "82", district: "North Waziristan" },
  { district_id: "83", district: "Nowshera" },
  { district_id: "84", district: "Nushki" },
  { district_id: "85", district: "Okara" },
  { district_id: "86", district: "Orakzai Agency" },
  { district_id: "87", district: "Pakpattan" },
  { district_id: "88", district: "Panjgur" },
  { district_id: "89", district: "Peshawar" },
  { district_id: "90", district: "Pishin" },
  { district_id: "91", district: "Quetta" },
  { district_id: "92", district: "Rahim Yar Khan" },
  { district_id: "93", district: "Rajan Pur" },
  { district_id: "94", district: "Rawalpindi" },
  { district_id: "95", district: "Sahiwal" },
  { district_id: "96", district: "Sanghar" },
  { district_id: "97", district: "Sargodha" },
  { district_id: "98", district: "Shangla" },
  { district_id: "99", district: "Sheikhupura" },
  { district_id: "100", district: "Sherani" },
  { district_id: "101", district: "Shikarpur" },
  { district_id: "102", district: "Sialkot" },
  { district_id: "103", district: "Sibi" },
  { district_id: "104", district: "South Waziristan" },
  { district_id: "105", district: "Sukkur" },
  { district_id: "106", district: "Swabi" },
  { district_id: "107", district: "Swat" },
  { district_id: "108", district: "Tando Muhammad Khan" },
  { district_id: "109", district: "Tank" },
  { district_id: "110", district: "Tharparkar" },
  { district_id: "111", district: "Thatta" },
  { district_id: "112", district: "Toba Tek Singh" },
  { district_id: "113", district: "Umarkot" },
  { district_id: "114", district: "Upper Dir" },
  { district_id: "115", district: "Vehari" },
  { district_id: "116", district: "Zhob" },
  { district_id: "117", district: "Ziarat" },
  { district_id: "118", district: "Balochistan" },
];

export const districtOptions = districts.map((district) => {
  return { value: district.district, name: district.district };
});

export const provinces = [
  { value: "1", name: "Balochistan" },
  { value: "2", name: "F.A.T.A" },
  { value: "3", name: "KPK" },
  { value: "4", name: "Punjab" },
  { value: "5", name: "Sindh" },
];
export const buyers = [
  { value: "1", name: "A J Textile Mills Ltd" },
  { value: "2", name: "A.A. Cotton Mills Ltd" },
  { value: "3", name: "A.G. Textile Mills Ltd" },
  { value: "4", name: "Abbas Spinning & Weaving Mills Ltd" },
  { value: "5", name: "Abdullah Fibres Pvt Ltd" },
  { value: "6", name: "Abdullah Textile Mills Pvt Ltd" },
  { value: "7", name: "Acro Spinning And Weaving Mills Ltd" },
  { value: "8", name: "Acro Textile Mills Limited" },
  { value: "9", name: "Adil Enterprises" },
  { value: "10", name: "Adil Textile Mills Ltd" },
  { value: "11", name: "Adnan Textile Mills Pvt Ltd" },
  { value: "12", name: "Afghan Maihan Dost Ltd" },
  { value: "13", name: "Afzal Cloth Mills Ltd" },
  { value: "14", name: "Afzal Spinning Mills Pvt Ltd" },
  { value: "15", name: "Ahad Fibres Pvt Ltd" },
  { value: "16", name: "Ahmad Cotton Industries" },
  { value: "17", name: "Ahmad Hassan Textile Mills Ltd" },
  { value: "18", name: "Ahmed Fine Textile Mills Ltd" },
  { value: "19", name: "Ahmed Oriental Textile Mills Ltd" },
  { value: "20", name: "Ahoud Textile Mills Ltd" },
  { value: "21", name: "AHY Plastic Industry Pvt Ltd" },
  { value: "22", name: "Akram Industries Ltd" },
  { value: "23", name: "Al Burque Enterprises" },
  { value: "24", name: "Al Karam Textile Mills Pvt Ltd" },
  { value: "25", name: "Al Muqeet Textiles Pvt Ltd" },
  { value: "26", name: "Al Nasr Textiles Ltd" },
  { value: "27", name: "Al Textiles Pvt Ltd" },
  { value: "28", name: "Alam Cotton Mills Pvt Ltd" },
  { value: "29", name: "Alhamd Corporation Pvt Ltd" },
  { value: "30", name: "Ali Akbar Spining Mills Ltd" },
  { value: "31", name: "Ali Asghar Textile Mills Ltd" },
  { value: "32", name: "Allawasaya Spinning Mills Pvt Ltd" },
  { value: "33", name: "Allawasaya Textile & Finishing Mills Ltd" },
  { value: "34", name: "Alliance Textile Mills Ltd" },
  { value: "35", name: "Al-Qadir Textile Mills Ltd" },
  { value: "36", name: "Amer Cotton Mills Pvt Ltd" },
  { value: "37", name: "Amin Textile Mills Pvt Ltd" },
  { value: "38", name: "Amir Sadat Sakandari Ltd" },
  { value: "39", name: "Amjad Textile Mills Ltd" },
  { value: "40", name: "AMK Traders" },
  { value: "41", name: "Amna Industries Pvt Ltd" },
  { value: "42", name: "Amtex Limited" },
  { value: "43", name: "AN Textile Industries" },
  { value: "44", name: "AN Textile Industries" },
  { value: "45", name: "Anchor Commodities Pvt Ltd" },
  { value: "46", name: "Anmol Textile Mills Ltd" },
  { value: "47", name: "Anoud Textile Mills Ltd" },
  { value: "48", name: "Apollo Textile Mills Ltd" },
  { value: "49", name: "Arain Textile Mills Ltd" },
  { value: "50", name: "Arsalan Muradi Ltd" },
  { value: "51", name: "Arshad Corporation Pvt Ltd" },
  { value: "52", name: "Arshad Textile Mills Ltd" },
  { value: "53", name: "Artistic Denim Mills Ltd" },
  { value: "54", name: "Artistic Fabric Mills Pvt Ltd" },
  { value: "55", name: "Artistic Milliners Pvt Ltd" },
  { value: "56", name: "Artistic Spinning Mills Pvt Ltd" },
  { value: "57", name: "Asher Imran Spinning Mills Pvt Ltd" },
  { value: "58", name: "Asim Textile Mills Ltd" },
  { value: "59", name: "Ayesha Group of Companies" },
  { value: "60", name: "Ayesha Spinning Mills Ltd" },
  { value: "61", name: "Ayesha Textile Mills Ltd" },
  { value: "62", name: "Azam Textile Mills Ltd" },
  { value: "63", name: "Azgard Nine Ltd" },
  { value: "64", name: "Babri Cotton Mills Ltd" },
  { value: "65", name: "Bajwa Spinning Mills Ltd" },
  { value: "66", name: "Basfa Textile Pvt Ltd" },
  { value: "67", name: "Bashir Cotton Mills Pvt Ltd" },
  { value: "68", name: "Best Exports Pvt Ltd" },
  { value: "69", name: "Best Fibres Pvt Ltd" },
  { value: "70", name: "Bhanero Textile Mills Ltd" },
  { value: "71", name: "Bhimra Textile Mills Pvt Ltd" },
  { value: "72", name: "Big Bird Foods Pvt Ltd" },
  { value: "73", name: "Bilal Fibres Ltd" },
  { value: "74", name: "Bisma Textile Mills Ltd" },
  { value: "75", name: "Blessed Textile Ltd" },
  { value: "76", name: "Brothers Enterprise Pvt Ltd" },
  { value: "77", name: "Burewala Textile Mills Ltd" },
  { value: "78", name: "C A Textile Mills Pvt Ltd" },
  { value: "79", name: "Chakwal Spinning Mills Ltd" },
  { value: "80", name: "Chaudhary Sugar Mills Ltd" },
  { value: "81", name: "Chawla Spinning Mills Ltd" },
  { value: "82", name: "Chenab ltd" },
  { value: "83", name: "Chiniot Textile Mills Ltd" },
  { value: "84", name: "Colony Textile Mills Ltd" },
  { value: "85", name: "Combine Spinning Pvt Ltd" },
  { value: "86", name: "Comfort Knitwears Pvt Ltd" },
  { value: "87", name: "Cotton Broker" },
  { value: "88", name: "Crescent Bahuman Ltd" },
  { value: "89", name: "Crescent Boards Ltd" },
  { value: "90", name: "Crescent Cotton Mills Ltd" },
  { value: "91", name: "Crescent Fibres Ltd" },
  { value: "92", name: "Crescent Steel & Allied Pvt Ltd" },
  { value: "93", name: "Crescent Sugar Mills & Distillery Ltd" },
  { value: "94", name: "Crescent Textile Mills Ltd" },
  { value: "95", name: "D S Industries Pvt Ltd" },
  { value: "96", name: "Daad Malang Ltd" },
  { value: "97", name: "Dadasons Pvt Ltd" },
  { value: "98", name: "Dar Es Salaam Textile Mills Ltd" },
  { value: "99", name: "Dawood Cotton Mills Ltd" },
  { value: "100", name: "Dawood Spinning Mills Pvt Ltd" },
  { value: "101", name: "Dewan Farooque Spining Mills Ltd" },
  { value: "102", name: "Dewan Khalid Textile Mills Ltd" },
  { value: "103", name: "Dewan Mushtaq Textile Mills Ltd" },
  { value: "104", name: "Dewan Textile Mills Ltd" },
  { value: "105", name: "Diamond Fabrics Ltd" },
  { value: "106", name: "Diamond International Corporation Ltd" },
  { value: "107", name: "Diamond Textiles / S S W" },
  { value: "108", name: "Din Textile Mills Ltd" },
  { value: "109", name: "Dossa Cotton And Gen Trading Pvt Ltd" },
  { value: "110", name: "Dostsons Cotton Mills Pvt Ltd" },
  { value: "111", name: "Dunavant Asia Ltd" },
  { value: "112", name: "Eastern Spinning Mills Ltd" },
  { value: "113", name: "Eisa Sadaqat Ltd" },
  { value: "114", name: "Ejaz Spinning Mills Ltd" },
  { value: "115", name: "Ejaz Textile Mills Ltd" },
  { value: "116", name: "Ellcot Spinning Mills Ltd" },
  { value: "117", name: "Equity Textile Mills Ltd" },
  { value: "118", name: "Faisal Asad Textile Mills Ltd" },
  { value: "119", name: "Faisal Fabrics Ltd" },
  { value: "120", name: "Faisal Spinning Mills Ltd" },
  { value: "121", name: "Faizcargo Pvt Ltd" },
  { value: "122", name: "Famous Textile Mills Ltd" },
  { value: "123", name: "Fanz Spinning Mills Ltd" },
  { value: "124", name: "Fashion Knit Industries" },
  { value: "125", name: "Fateh Textile Mills Ltd" },
  { value: "126", name: "Fatima Enterprises Pvt Ltd" },
  { value: "127", name: "Fawad Textile Mills Ltd" },
  { value: "128", name: "Fazal Cloth Mills Ltd" },
  { value: "129", name: "Fazal Textile Mills Ltd" },
  { value: "130", name: "Feroze Textile Industries Mills Pvt. Ltd." },
  { value: "131", name: "Fimco Tex Industries" },
  { value: "132", name: "Friends Feed Mill" },
  { value: "133", name: "Friendship Textile Mills Pvt Ltd" },
  { value: "134", name: "Gadoon Textile Mills Ltd" },
  { value: "135", name: "Galaxy Textile Mills Ltd" },
  { value: "136", name: "Gam Corp Pvt Ltd" },
  { value: "137", name: "Ghazi Fabrics International Ltd" },
  { value: "138", name: "Glamor Textile Mills Ltd" },
  { value: "139", name: "Gohar Textile Mills Pvt Ltd" },
  { value: "140", name: "Golden Harvest Foods Pvt Ltd" },
  { value: "141", name: "Green House Ltd" },
  { value: "142", name: "GTN Textile Mills Ltd" },
  { value: "143", name: "Gul Ahmed Textile Mills Ltd" },
  { value: "144", name: "Gulistan Spinning Mills Ltd" },
  { value: "145", name: "Gulistan Textile Mills Ltd" },
  { value: "146", name: "Gulshan Spinning Mills Ltd" },
  { value: "147", name: "H. A. Haq Spinning Mills Pvt Ltd" },
  { value: "148", name: "H.A. Fibres Pvt Ltd" },
  { value: "149", name: "Habib Haseeb Spinning Mills Pvt Ltd" },
  { value: "150", name: "Haji Mohd Ismail Mills Ltd" },
  { value: "151", name: "Hamid Sudais Ltd" },
  { value: "152", name: "Hantex" },
  { value: "153", name: "Harum Textile Mills Ltd" },
  { value: "154", name: "Hassan Limited" },
  { value: "155", name: "Hassan Spinning Mills Ltd" },
  { value: "156", name: "Hazbi Chemicals" },
  { value: "157", name: "Hilal Foods Pvt Ltd" },
  { value: "158", name: "Hira Textile Mills Ltd" },
  { value: "159", name: "Husnain Textile Mills Pvt Ltd" },
  { value: "160", name: "Hussain Mills Ltd" },
  { value: "161", name: "Ibrahim Fibres" },
  { value: "162", name: "Ideal Spinning Mills Ltd" },
  { value: "163", name: "Idrees Textile Mills Ltd" },
  { value: "164", name: "Ihsan Cotton Products Pvt Ltd" },
  { value: "165", name: "Ihsan Raiwind Mills Pvt Ltd" },
  { value: "166", name: "Ihsan Sons Pvt Ltd" },
  { value: "167", name: "Indus Dyeing And Mfg Co Ltd" },
  { value: "168", name: "Indus Home Ltd" },
  { value: "169", name: "Innovative Biscuits Pvt Ltd" },
  { value: "170", name: "Inter Loop Pvt Ltd" },
  { value: "171", name: "International Pharma Labs" },
  { value: "172", name: "Ishaq Textile Mills Ltd" },
  { value: "173", name: "Island Textile Mills Ltd" },
  { value: "174", name: "ITHFZ Mills Ltd" },
  { value: "175", name: "Ittehad Pvt Ltd" },
  { value: "176", name: "J A Textile Mills Ltd" },
  { value: "177", name: "J K Fibre Mills Ltd" },
  { value: "178", name: "J K Spinning Mills Ltd" },
  { value: "179", name: "Jamhoor Textile Mills Ltd" },
  { value: "180", name: "Janana De Malucho Textile Mills Ltd" },
  { value: "181", name: "Jubilee Spinning & Weaving Mills Ltd" },
  { value: "182", name: "Kamal Spinning Mills Ltd" },
  { value: "183", name: "Karam-e-Kareem Spinning Mills Pvt Ltd" },
  { value: "184", name: "Kashir Textile Mills Limited" },
  { value: "185", name: "Kassim Textile Pvt Ltd" },
  { value: "186", name: "Kefayat Bahar Ltd" },
  { value: "187", name: "Khalid Shafique Spinning Mills Ltd" },
  { value: "188", name: "Khalid Siraj Textile Mills Ltd" },
  { value: "189", name: "Khas Textile Mills Pvt Ltd" },
  { value: "190", name: "Khawaja Bashir Ahmad & Co, Pvt Ltd" },
  { value: "191", name: "Khawaja Spinning Mills Ltd" },
  { value: "192", name: "Khokhar Textile Mills" },
  { value: "193", name: "Khushi Muhammad & Sons" },
  { value: "194", name: "Khyber Spinning Mills Ltd" },
  { value: "195", name: "Kohat Textile Mills Ltd" },
  { value: "196", name: "Kohinoor Industries Ltd" },
  { value: "197", name: "Kohinoor Spinning Mills Ltd" },
  { value: "198", name: "Kohinoor Textile Mills Ltd" },
  { value: "199", name: "Kunjah Textile Mills Ltd" },
  { value: "200", name: "Lanmol Textile Mills Ltd" },
  { value: "201", name: "Latif Cotton Mills Ltd" },
  { value: "202", name: "Latif Fibres Pvt Ltd" },
  { value: "203", name: "Latif Textile Mills Pvt Ltd" },
  { value: "204", name: "Liberty Mills Ltd" },
  { value: "205", name: "Lotte Kolson Pvt Ltd" },
  { value: "206", name: "Louis Dreyfus Co, Pakistan Pvt Ltd" },
  { value: "207", name: "Lucky Cotton Mills Pvt Ltd" },
  { value: "208", name: "Lucky Textile Mills" },
  { value: "209", name: "Lyallpur Textiles" },
  { value: "210", name: "M G M Corporation Pvt Ltd" },
  { value: "211", name: "Mahmood Textile Mills Ltd" },
  { value: "212", name: "Malmo Foods Pvt Ltd" },
  { value: "213", name: "Maqbool Textile Mills Ltd" },
  { value: "214", name: "Marral Textile Mills Ltd" },
  { value: "215", name: "Masco Spinning Mills Pvt Ltd" },
  { value: "216", name: "Masood Fabrics Ltd" },
  { value: "217", name: "Masood Spinning Mills Ltd" },
  { value: "218", name: "Masood Textile Mills Ltd" },
  { value: "219", name: "Master Textile Mills Ltd" },
  { value: "220", name: "Mayfair Spinning Mills Ltd" },
  { value: "221", name: "Mehraan Ramzan Tetile Mills Ltd" },
  { value: "222", name: "Mehtabi Spinning Mills Ltd" },
  { value: "223", name: "Mekotex Pvt Ltd" },
  { value: "224", name: "Metco Textile Mills Ltd" },
  { value: "225", name: "Mian Akber Trading Corporation" },
  { value: "226", name: "Mian Irfan Majeed CB" },
  { value: "227", name: "Mian Muhammad Saeed" },
  { value: "228", name: "MIMA Cotton Mills Ltd" },
  { value: "229", name: "Moiz Textile Mills Ltd" },
  { value: "230", name: "Monnoowal Textile Mills Ltd" },
  { value: "231", name: "Morarjee Textile Mills Ltd" },
  { value: "232", name: "Mukhtar Soap And Oleo Chemicals" },
  { value: "233", name: "Multan Spinning Mills Ltd" },
  { value: "234", name: "Mustaqim Dyeing & Printing Industries Pvt Ltd" },
  { value: "235", name: "N P Cotton Mills Pvt Ltd" },
  { value: "236", name: "N P Spinning Mills Ltd" },
  { value: "237", name: "N P Waterproof Textile Mills Ltd" },
  { value: "238", name: "Nadeem Textile Mills Ltd" },
  { value: "239", name: "Nafeesa Textile Mills Ltd" },
  { value: "240", name: "Nagaria Textile Mills Pvt Ltd" },
  { value: "241", name: "Nagina Cotton Mills Ltd" },
  { value: "242", name: "Nagra Spinning Mills Pvt Ltd" },
  { value: "243", name: "Naseem Enterprises Pvt Ltd" },
  { value: "244", name: "Naseem Exports Pvt Ltd" },
  { value: "245", name: "National Feeds Ltd" },
  { value: "246", name: "National Spinning Mills Ltd" },
  { value: "247", name: "Naveed Enterprise" },
  { value: "248", name: "Naveed Nawaz Textile Pvt Ltd" },
  { value: "249", name: "Naveena Exports Ltd" },
  { value: "250", name: "Neelum Corporation" },
  { value: "251", name: "Nestle Pakistan Ltd" },
  { value: "252", name: "Nisar Spinning Mills Pvt Ltd" },
  { value: "253", name: "Nishat ( Chunian ) Ltd" },
  { value: "254", name: "Nishat Mills Ltd" },
  { value: "255", name: "Noon Textile Mills Ltd" },
  { value: "256", name: "North Star Textile Mills Ltd" },
  { value: "257", name: "Olympia Blended Fibre Mills Ltd" },
  { value: "258", name: "Olympia Spinning & Weaving Mills Ltd" },
  { value: "259", name: "Orient Textile Mills Ltd" },
  { value: "260", name: "Pacific Chartering And Trading Pvt Ltd" },
  { value: "261", name: "Pak Kuwait Textile Mills Ltd" },
  { value: "262", name: "Pakistan Dairy Products Pvt Ltd" },
  { value: "263", name: "Pakistan Tobacco Company" },
  { value: "264", name: "Paradise Spinning Mills Pvt Ltd" },
  { value: "265", name: "Paramount Spinning Mills Ltd" },
  { value: "266", name: "Pioneer Jute Mills Ltd" },
  { value: "267", name: "Pioneer Spinning Mills Ltd" },
  { value: "268", name: "Premium Textile Mills Ltd" },
  { value: "269", name: "Procter & Gamble Pakistan Pvt Ltd" },
  { value: "270", name: "Punjab Oil Products Pvt Ltd" },
  { value: "271", name: "Qadri Textile Mills Ltd" },
  { value: "272", name: "Quality Textile Mills Ltd" },
  { value: "273", name: "Quetta Textile Mills Ltd" },
  { value: "274", name: "Qureshi Textile Mills Ltd" },
  { value: "275", name: "Rafi Sadat Ltd" },
  { value: "276", name: "Rafiq Spinning Mills Pvt Ltd" },
  { value: "277", name: "Rafiullah Faqirzada Ltd" },
  { value: "278", name: "Rahman Cotton Mills Ltd" },
  { value: "279", name: "Ramin Sadat Co Ltd" },
  { value: "280", name: "Ramzan Buksh Textile Mills Ltd" },
  { value: "281", name: "Ravi Spinning Mills Ltd" },
  { value: "282", name: "Ravi Textile Mills Ltd" },
  { value: "283", name: "Regent Textile Industries Ltd" },
  { value: "284", name: "Rehmat Wazir Textile Mills Ltd" },
  { value: "285", name: "Reliance Cotton Spinning Mills Ltd" },
  { value: "286", name: "Relliance Weaving Mills Ltd" },
  { value: "287", name: "Resham Textile Industries Ltd" },
  { value: "288", name: "Riaz Manzoor Corp" },
  { value: "289", name: "Riaz Textile Mills Pvt Ltd" },
  { value: "290", name: "Roomi Fabrics Ltd" },
  { value: "291", name: "Royal Textile Mills Ltd" },
  { value: "292", name: "Ruby Textile Mills Ltd" },
  { value: "293", name: "S S Enterprises" },
  { value: "294", name: "S.I.S Traders" },
  { value: "295", name: "Saif Textile Mills Ltd" },
  { value: "296", name: "Sajjad Textile Mills Ltd" },
  { value: "297", name: "Salfi Textile Mills Ltd" },
  { value: "298", name: "Sally Textile Mills Ltd" },
  { value: "299", name: "Salman Noman Enterprises Ltd" },
  { value: "300", name: "Sapphire Fibres Ltd" },
  { value: "301", name: "Sapphire Textile Mills Ltd" },
  { value: "302", name: "Sarfaraz Yaqub Textile Mills Ltd" },
  { value: "303", name: "Sargodha Spinning Mills Ltd" },
  { value: "304", name: "Sarhad Textile Mills Ltd" },
  { value: "305", name: "Saritow Spinning Mills Ltd" },
  { value: "306", name: "Sediq Usman Ltd" },
  { value: "307", name: "Shadab Textile Mills Ltd" },
  { value: "308", name: "Shadman Cotton Mills Ltd" },
  { value: "309", name: "Shafi Spinning Mills Ltd" },
  { value: "310", name: "Shaheen Cotton Mills Ltd" },
  { value: "311", name: "Shahi Enterprises Pvt Ltd" },
  { value: "312", name: "Shahnawaz Textiles Ltd" },
  { value: "313", name: "Shahpur Textile Mills Ltd" },
  { value: "314", name: "Shahzad Textile Mills Ltd" },
  { value: "315", name: "Shakarganj Mills Ltd" },
  { value: "316", name: "Shams Textile Mills Ltd" },
  { value: "317", name: "Sheikhupura Textile Mills Ltd" },
  { value: "318", name: "Siara Textile Mills Pvt Ltd" },
  { value: "319", name: "Siddiqsons Denim Mills Ltd" },
  { value: "320", name: "Sikandar Commodities" },
  { value: "321", name: "Silver Textile Factory" },
  { value: "322", name: "Silverline Spinning Mills Pvt. Ltd." },
  { value: "323", name: "Simba Corporation Pvt Ltd" },
  { value: "324", name: "Sitara Spinning Mills Ltd" },
  { value: "325", name: "Sohail Textile Mills Ltd" },
  { value: "326", name: "Soorty Enterprises Pvt Ltd" },
  { value: "327", name: "Stallion Textiles Pvt Ltd" },
  { value: "328", name: "Standard Spinning Mills Ltd" },
  { value: "329", name: "Standard Textile Mills Ltd" },
  { value: "330", name: "Star Textile Mills Ltd" },
  { value: "331", name: "Suleman Spinning Mills Ltd" },
  { value: "332", name: "Sunrays Textile Mills Ltd" },
  { value: "333", name: "Superior Textile Mills Pvt Ltd" },
  { value: "334", name: "Suraj Cotton Mills Ltd" },
  { value: "335", name: "Surriya Textile Mills Pvt Ltd" },
  { value: "336", name: "Tanveer Cotton Mills Pvt Ltd" },
  { value: "337", name: "Tanveer Enterprises" },
  { value: "338", name: "Tanveer Spinning & Weaving Mills Pvt Ltd" },
  { value: "339", name: "Tata Textile Mills Ltd" },
  { value: "340", name: "Tauseef Enterprises Pvt Ltd" },
  { value: "341", name: "Tayyab Textile Mills Ltd" },
  { value: "342", name: "Texstyle Corporation" },
  { value: "343", name: "Textile Mill" },
  { value: "344", name: "The Lahore Textile Mills Ltd" },
  { value: "345", name: "Three Star Hosiery Mills Pvt Ltd" },
  { value: "346", name: "Tritex Cotton Mills Ltd" },
  { value: "347", name: "UBL Centralized Trade Processing Unit" },
  { value: "348", name: "Ulfat Textile Mills Pvt Ltd" },
  { value: "349", name: "Umar Spinning Mills Pvt Ltd" },
  { value: "350", name: "Umer Fabrics Ltd" },
  { value: "351", name: "UN World Food Programme" },
  { value: "352", name: "United Spinning Mills" },
  { value: "353", name: "Urooj International" },
  { value: "354", name: "Usman Ltd" },
  { value: "355", name: "Volka Food International Ltd" },
  { value: "356", name: "White Pearl Jute Mills Ltd" },
  { value: "357", name: "Winner Foods Pvt Ltd" },
  { value: "358", name: "Wisal Kamal Fabrics Pvt Ltd" },
  { value: "359", name: "Wizitex Time Industries Pvt Ltd" },
  { value: "360", name: "World Food Programme" },
  { value: "361", name: "Yahya Textile Mills Ltd" },
  { value: "362", name: "Yunus Textile Mills Ltd" },
  { value: "363", name: "Z R Corporation" },
  { value: "364", name: "Z.A Corporation Pvt Ltd" },
  { value: "365", name: "Zahid Corporation Pvt Ltd" },
  { value: "366", name: "Zahidjee Fabrics Mills Ltd" },
  { value: "367", name: "Zahidjee Textile Mills Ltd" },
  { value: "368", name: "Zahra Textile Mills Ltd" },
  { value: "369", name: "Zain Enterprise" },
  { value: "370", name: "Zaman Textile Mills Ltd" },
  { value: "371", name: "Zephyr Textile Mills Ltd" },
  { value: "372", name: "Zulaikha Textile Mills Ltd" },
  { value: "373", name: "Zumar Textile Mills Pvt Ltd" },
];

// export const optionProductsByProducts = [
//   { value: "11", name: "banola", product_id: "1", product: "cotton" },
//   { value: "13", name: "banola_khal", product_id: "1", product: "cotton" },
//   { value: "12", name: "banola_oil", product_id: "1", product: "cotton" },
//   { value: "7", name: "phutty", product_id: "1", product: "cotton" },
//   { value: "37", name: "sarso oil", product_id: "9", product: "edible oil" },
//   { value: "38", name: "sunflower oil", product_id: "9", product: "edible oil" },
//   { value: "39", name: "canola oil", product_id: "9", product: "edible oil" },
//   { value: "54", name: "sarso seed", product_id: "9", product: "edible oil" },
//   { value: "61", name: "canola seed", product_id: "9", product: "edible oil" },
//   { value: "55", name: "sunflower seed", product_id: "9", product: "edible oil" },
//   { value: "63", name: "sarso khal", product_id: "9", product: "edible oil" },
//   { value: "19", name: "maize", product_id: "5", product: "maize" },
//   { value: "16", name: "wheat", product_id: "3", product: "wheat" },
//   { value: "62", name: "wheat straw", product_id: "3", product: "wheat" },
//   { value: "59", name: "flour", product_id: "3", product: "wheat" },

//   {value:"65", name:"Bajra", product_id:"12", product:"Bajra"},
//   {value:"19", name:"Corn (Grade A)", product_id:"5", product:"Corn" },
//   {value:"83", name:"Corn (Grade B)", product_id:"5", product:"Corn"},
//   {value:"84", name:"Corn (Grade C)", product_id:"5", product:"Corn"}
// ];

export const optionProductsByProducts = [
  { value: "65", name: "Bajra", product_id: "12", product: "Bajra" },
  { value: "19", name: "Corn (Grade A)", product_id: "5", product: "Corn" },
  { value: "83", name: "Corn (Grade B)", product_id: "5", product: "Corn" },
  { value: "84", name: "Corn (Grade C)", product_id: "5", product: "Corn" },
  { value: "11", name: "Banola", product_id: "1", product: "Cotton" },
  { value: "13", name: "Banola-Khal", product_id: "1", product: "Cotton" },
  { value: "12", name: "Banola-Oil", product_id: "1", product: "Cotton" },
  { value: "7", name: "Phutti", product_id: "1", product: "Cotton" },
  { value: "67", name: "Aseel Dates", product_id: "13", product: "Dates" },
  { value: "66", name: "Karbala Dates", product_id: "13", product: "Dates" },
  { value: "74", name: "Muzafati Dates", product_id: "13", product: "Dates" },
  { value: "68", name: "Rangkat Chuara", product_id: "13", product: "Dates" },
  { value: "73", name: "Zahedi Dates", product_id: "13", product: "Dates" },
  { value: "61", name: "Canola", product_id: "9", product: "Edible Oil" },
  { value: "39", name: "Canola-Oil", product_id: "9", product: "Edible Oil" },
  { value: "54", name: "Sarso", product_id: "9", product: "Edible Oil" },
  { value: "63", name: "Sarso-Khal", product_id: "9", product: "Edible Oil" },
  { value: "37", name: "Sarso-Oil", product_id: "9", product: "Edible Oil" },
  { value: "40", name: "Soybean-Oil", product_id: "9", product: "Edible Oil" },
  { value: "55", name: "Sunflower", product_id: "9", product: "Edible Oil" },
  {
    value: "38",
    name: "Sunflower-Oil",
    product_id: "9",
    product: "Edible Oil",
  },
  { value: "80", name: "Ajwain", product_id: "14", product: "Herbals" },
  { value: "77", name: "Honey", product_id: "14", product: "Herbals" },
  { value: "78", name: "Ispaghol", product_id: "14", product: "Herbals" },
  { value: "79", name: "Kalonji", product_id: "14", product: "Herbals" },
  { value: "82", name: "Saunf", product_id: "14", product: "Herbals" },
  { value: "81", name: "Tukh Malanga", product_id: "14", product: "Herbals" },
  { value: "64", name: "Till", product_id: "11", product: "Sesame" },
  { value: "70", name: "Hybird Chilli", product_id: "10", product: "Spices" },
  { value: "69", name: "Longi Chilli", product_id: "10", product: "Spices" },
  {
    value: "71",
    name: "Rich Star Chilli",
    product_id: "10",
    product: "Spices",
  },
  { value: "59", name: "Flour", product_id: "3", product: "Wheat" },
  { value: "72", name: "Maida", product_id: "3", product: "Wheat" },
  { value: "75", name: "Sorghum", product_id: "3", product: "Wheat" },
  { value: "62", name: "Straw", product_id: "3", product: "Wheat" },
  { value: "16", name: "Wheat", product_id: "3", product: "Wheat" },
];

export const optionsWheat = [
  { value: "16", name: "wheat", product_id: "3", product: "wheat" },
  { value: "62", name: "wheat straw", product_id: "3", product: "wheat" },
  { value: "59", name: "flour", product_id: "3", product: "wheat" },
];

export const optionsSugar = [
  { value: "1", name: "sugar", product_id: "2", product: "sugarcane" },
  { value: "2", name: "molasses", product_id: "2", product: "sugarcane" },
  { value: "3", name: "ethanol", product_id: "2", product: "sugarcane" },
];

export const optionsPulses = [
  { value: "42", name: "pigeon-pea-thick", product_id: "8", product: "pulses" },
  { value: "43", name: "pigeon-pea-thin", product_id: "8", product: "pulses" },
  {
    value: "44",
    name: "gram-pulse-thick-AS",
    product_id: "8",
    product: "pulses",
  },
  {
    value: "45",
    name: "gram-pulse-thin-AS",
    product_id: "8",
    product: "pulses",
  },
  { value: "46", name: "mash-sabut-2", product_id: "8", product: "pulses" },
  { value: "47", name: "mash-shell-thick", product_id: "8", product: "pulses" },
  {
    value: "48",
    name: "mash-shell-thin-2",
    product_id: "8",
    product: "pulses",
  },
  { value: "49", name: "mash-S.Q-thick", product_id: "8", product: "pulses" },
  { value: "50", name: "mash-S.Q-thin", product_id: "8", product: "pulses" },
  { value: "51", name: "masoor-sabut-1", product_id: "8", product: "pulses" },
  { value: "52", name: "masoor-sabut-2", product_id: "8", product: "pulses" },
  { value: "53", name: "masoor-pulse-red", product_id: "8", product: "pulses" },
  { value: "54", name: "moong-sabut-1", product_id: "8", product: "pulses" },
  { value: "55", name: "moong-sabut-2", product_id: "8", product: "pulses" },
  { value: "56", name: "moong-shell-1", product_id: "8", product: "pulses" },
  { value: "57", name: "moong-washed-1", product_id: "8", product: "pulses" },
  { value: "58", name: "moong-washed-2", product_id: "8", product: "pulses" },
  { value: "59", name: "gram-white-9mm", product_id: "8", product: "pulses" },
  { value: "60", name: "gram-white-7mm", product_id: "8", product: "pulses" },
  {
    value: "61",
    name: "white-lubya-thick",
    product_id: "8",
    product: "pulses",
  },
  { value: "62", name: "gram-black-thick", product_id: "8", product: "pulses" },
  { value: "63", name: "gram-black-thin", product_id: "8", product: "pulses" },
  { value: "64", name: "red-lubya-1", product_id: "8", product: "pulses" },
  { value: "65", name: "red-lubya-2", product_id: "8", product: "pulses" },
  {
    value: "101",
    name: "white-lubya-thin",
    product_id: "8",
    product: "pulses",
  },
];

export const optionsSpices = [
  { value: "104", name: "black-pepper", product_id: "10", product: "spices" },
  {
    value: "105",
    name: "black-pepper-powder",
    product_id: "10",
    product: "spices",
  },
  { value: "106", name: "cinnamon", product_id: "10", product: "spices" },
  { value: "107", name: "clove", product_id: "10", product: "spices" },
  { value: "108", name: "coriander-seed", product_id: "10", product: "spices" },
  {
    value: "109",
    name: "coriander-seed-powder",
    product_id: "10",
    product: "spices",
  },
  { value: "110", name: "cumin-black", product_id: "10", product: "spices" },
  { value: "111", name: "cumin-white", product_id: "10", product: "spices" },
  {
    value: "112",
    name: "large-black-cardamom",
    product_id: "10",
    product: "spices",
  },
  {
    value: "113",
    name: "red-chilli-powder",
    product_id: "10",
    product: "spices",
  },
  {
    value: "114",
    name: "red-chilli-whole",
    product_id: "10",
    product: "spices",
  },
  { value: "115", name: "small-cardamom", product_id: "10", product: "spices" },
  { value: "116", name: "turmeric", product_id: "10", product: "spices" },
  { value: "125", name: "longi-chilli", product_id: "10", product: "spices" },
  { value: "126", name: "hybird-chilli", product_id: "10", product: "spices" },
  {
    value: "127",
    name: "rich-star-chilli",
    product_id: "10",
    product: "spices",
  },
  { value: "131", name: "saunf", product_id: "10", product: "spices" },
];

export const optionsEdibleOils = [
  { value: "39", name: "canola oil", product_id: "9", product: "edible-oils" },
  { value: "37", name: "sarso oil", product_id: "9", product: "edible-oils" },
  {
    value: "38",
    name: "sunflower oil",
    product_id: "9",
    product: "edible-oils",
  },
];

export const optionsRice = [
  { value: "76", name: "milled-rice", product_id: "4", product: "rice" },
];

export const optionsRiceVariety = [
  { value: "2", name: "386 Basmati-New", product_id: "4", product: "rice" },
  { value: "4", name: "386 Basmati-Old", product_id: "4", product: "rice" },
  { value: "16", name: "Punia 1121-1", product_id: "4", product: "rice" },
  { value: "17", name: "Punia 1121-2", product_id: "4", product: "rice" },
  { value: "22", name: "1121 Basmati-1", product_id: "4", product: "rice" },
  { value: "23", name: "1121 Basmati-2", product_id: "4", product: "rice" },
  { value: "102", name: "1121 Basmati-3", product_id: "4", product: "rice" },
  { value: "29", name: "Irri 6 Sabut-1", product_id: "4", product: "rice" },
  { value: "103", name: "Irri Tota", product_id: "4", product: "rice" },
  { value: "31", name: "Sila 1121-1", product_id: "4", product: "rice" },
  { value: "35", name: "Tota Basmati", product_id: "4", product: "rice" },
  { value: "38", name: "Sila Super Punjab", product_id: "4", product: "rice" },
  { value: "39", name: "Super Basmati Sind", product_id: "4", product: "rice" },
  {
    value: "120",
    name: "Kainat Double steam",
    product_id: "4",
    product: "rice",
  },
  { value: "121", name: "Super Kernel ", product_id: "4", product: "rice" },
  { value: "122", name: "386", product_id: "4", product: "rice" },
  {
    value: "123",
    name: "Short grain (tota)",
    product_id: "4",
    product: "rice",
  },
  { value: "124", name: "Irri 6", product_id: "4", product: "rice" },
];

export const optionsMaize = [
  { value: "104", name: "black-pepper", product_id: "4", product: "maize" },
  {
    value: "105",
    name: "black-pepper-powder",
    product_id: "4",
    product: "maize",
  },
  { value: "106", name: "cinnamon", product_id: "4", product: "maize" },
  { value: "107", name: "clove", product_id: "4", product: "maize" },
];

export const byProductOptions = [
  { value: "1", text: "Phutti" },
  { value: "2", text: "Banola" },
  { value: "3", text: "Banola-Oil" },
  { value: "4", text: "Banola-Khal" },
  { value: "5", text: "Lint-Cotton" },
  { value: "6", text: "Wheat" },
  { value: "7", text: "Rice" },
  { value: "8", text: "Corn" },
  { value: "9", text: "Jodia Bazar" },
  { value: "10", text: "Akbari Mandi" },
  { value: "11", text: "Sugar-Mills" },
  { value: "12", text: "Pulses" },
  { value: "13", text: "Banola-Oil" },
  { value: "14", text: "Sarso-Oil" },
  { value: "15", text: "Sunflower-Oil" },
  { value: "16", text: "Canola-Oil" },
  { value: "17", text: "Soybean-Oil" },
  { value: "18", text: "Canola Oil" },
  { value: "19", text: "Crude Palm Oil" },
  { value: "20", text: "Palm Oil" },
  { value: "21", text: "Palm Olein" },
  { value: "22", text: "Soybean Oil" },
  { value: "23", text: "NYBOT Cotton Closing" },
  { value: "24", text: "Cotlook A Index" },
  { value: "25", text: "Brazilian Cotton Price Index" },
  { value: "26", text: "Bremen Index" },
  { value: "27", text: "Sugar #11" },
  { value: "28", text: "Sugar #5" },
  { value: "29", text: "Sarso" },
  { value: "30", text: "Sunflower" },
  { value: "31", text: "Wheat" },
  { value: "32", text: "Edible Oil" },
  { value: "33", text: "Spices" },
  { value: "34", text: "Flour" },
  { value: "35", text: "Paddy" },
  { value: "36", text: "Canola" },
  { value: "37", text: "Straw" },
  { value: "38", text: "Sarso-Khal" },
];

export const options = [
  {
    value: "1",
    name: "Abbottabad",
    province_id: "3",
    province: "KPK",
    district_id: "1",
    district: "Abbottabad",
  },
  {
    value: "2",
    name: "Abdul Hakim",
    province_id: "4",
    province: "Punjab",
    district_id: "46",
    district: "Khanewal",
  },
  {
    value: "3",
    name: "Ada Flour",
    province_id: "4",
    province: "Punjab",
    district_id: "21",
    district: "Dera Ghazi Khan",
  },
  {
    value: "4",
    name: "Adilpur",
    province_id: "5",
    province: "Sindh",
    district_id: "24",
    district: "Ghotki",
  },
  {
    value: "5",
    name: "Agency",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "82",
    district: "North Waziristan",
  },
  {
    value: "6",
    name: "Agency",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "104",
    district: "South Waziristan",
  },
  {
    value: "7",
    name: "Ahmadabad",
    province_id: "4",
    province: "Punjab",
    district_id: "85",
    district: "Okara",
  },
  {
    value: "8",
    name: "Ahmadpur East",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "9",
    name: "Ahmadpur Lumma",
    province_id: "4",
    province: "Punjab",
    district_id: "92",
    district: "Rahim Yar Khan",
  },
  {
    value: "10",
    name: "Ahmedpur Sial",
    province_id: "4",
    province: "Punjab",
    district_id: "38",
    district: "Jhang",
  },
  {
    value: "11",
    name: "Akora Khattak",
    province_id: "3",
    province: "KPK",
    district_id: "83",
    district: "Nowshera",
  },
  {
    value: "12",
    name: "Akri",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "13",
    name: "Alipur",
    province_id: "4",
    province: "Punjab",
    district_id: "76",
    district: "Muzaffargarh",
  },
  {
    value: "14",
    name: "Alipur Chatta",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "15",
    name: "Allahabad",
    province_id: "4",
    province: "Punjab",
    district_id: "92",
    district: "Rahim Yar Khan",
  },
  {
    value: "16",
    name: "Allai",
    province_id: "3",
    province: "KPK",
    district_id: "10",
    district: "Batgram",
  },
  {
    value: "17",
    name: "Alpuri",
    province_id: "3",
    province: "KPK",
    district_id: "98",
    district: "Shangla",
  },
  {
    value: "18",
    name: "Amangarh Indust.Area TC",
    province_id: "3",
    province: "KPK",
    district_id: "83",
    district: "Nowshera",
  },
  {
    value: "19",
    name: "Arifwala",
    province_id: "4",
    province: "Punjab",
    district_id: "87",
    district: "Pakpattan",
  },
  {
    value: "20",
    name: "Attock",
    province_id: "4",
    province: "Punjab",
    district_id: "2",
    district: "Attock",
  },
  {
    value: "21",
    name: "Attock Cantt.",
    province_id: "4",
    province: "Punjab",
    district_id: "2",
    district: "Attock",
  },
  {
    value: "22",
    name: "Awaran",
    province_id: "1",
    province: "Balochistan",
    district_id: "3",
    district: "Awaran",
  },
  {
    value: "23",
    name: "Aziz Bhatti Town",
    province_id: "4",
    province: "Punjab",
    district_id: "57",
    district: "Lahore City",
  },
  {
    value: "24",
    name: "Badah",
    province_id: "5",
    province: "Sindh",
    district_id: "59",
    district: "Larkana",
  },
  {
    value: "25",
    name: "Baddomalhi",
    province_id: "4",
    province: "Punjab",
    district_id: "77",
    district: "Narowal",
  },
  {
    value: "26",
    name: "Badin",
    province_id: "5",
    province: "Sindh",
    district_id: "4",
    district: "Badin",
  },
  {
    value: "27",
    name: "Baffa",
    province_id: "3",
    province: "KPK",
    district_id: "67",
    district: "Mansehra",
  },
  {
    value: "28",
    name: "Bagerji",
    province_id: "5",
    province: "Sindh",
    district_id: "105",
    district: "Sukkur",
  },
  {
    value: "29",
    name: "Bagh",
    province_id: "4",
    province: "Punjab",
    district_id: "38",
    district: "Jhang",
  },
  {
    value: "30",
    name: "Bahawalnagar",
    province_id: "4",
    province: "Punjab",
    district_id: "5",
    district: "Bahawalnagar",
  },
  {
    value: "31",
    name: "Bahawalpur",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "32",
    name: "Bahawalpur Cantt.",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "33",
    name: "Baiker",
    province_id: "1",
    province: "Balochistan",
    district_id: "20",
    district: "Dera Bughti",
  },
  {
    value: "34",
    name: "Bajaur Agency",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "7",
    district: "Bajaur Agency",
  },
  {
    value: "35",
    name: "Balakot",
    province_id: "3",
    province: "KPK",
    district_id: "67",
    district: "Mansehra",
  },
  {
    value: "36",
    name: "Baldia Town",
    province_id: "5",
    province: "Sindh",
    district_id: "41",
    district: "Karachi",
  },
  {
    value: "37",
    name: "Balnigor",
    province_id: "1",
    province: "Balochistan",
    district_id: "44",
    district: "Kech(Turbat)",
  },
  {
    value: "38",
    name: "Banda Daud Shah",
    province_id: "3",
    province: "KPK",
    district_id: "42",
    district: "Karak",
  },
  {
    value: "39",
    name: "Bandhi",
    province_id: "5",
    province: "Sindh",
    district_id: "80",
    district: "Nawabshah",
  },
  {
    value: "40",
    name: "Bannu",
    province_id: "3",
    province: "KPK",
    district_id: "8",
    district: "Bannu",
  },
  {
    value: "41",
    name: "Bannu Cantt.",
    province_id: "3",
    province: "KPK",
    district_id: "8",
    district: "Bannu",
  },
  {
    value: "42",
    name: "Bara",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "50",
    district: "Khyber Agency",
  },
  {
    value: "43",
    name: "Barang",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "7",
    district: "Bajaur Agency",
  },
  {
    value: "44",
    name: "Barkhan",
    province_id: "1",
    province: "Balochistan",
    district_id: "9",
    district: "Barkhan",
  },
  {
    value: "45",
    name: "Barshore",
    province_id: "1",
    province: "Balochistan",
    district_id: "90",
    district: "Pishin",
  },
  {
    value: "46",
    name: "Basirpur",
    province_id: "4",
    province: "Punjab",
    district_id: "85",
    district: "Okara",
  },
  {
    value: "47",
    name: "Basti Maluk",
    province_id: "4",
    province: "Punjab",
    district_id: "74",
    district: "Multan",
  },
  {
    value: "48",
    name: "Bat Khela",
    province_id: "3",
    province: "KPK",
    district_id: "13",
    district: "Buner",
  },
  {
    value: "49",
    name: "Batgram",
    province_id: "3",
    province: "KPK",
    district_id: "10",
    district: "Batgram",
  },
  {
    value: "50",
    name: "Begowala",
    province_id: "4",
    province: "Punjab",
    district_id: "102",
    district: "Sialkot",
  },
  {
    value: "51",
    name: "Bela",
    province_id: "1",
    province: "Balochistan",
    district_id: "60",
    district: "Lasbella",
  },
  {
    value: "52",
    name: "Berani",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "53",
    name: "Besham",
    province_id: "3",
    province: "KPK",
    district_id: "98",
    district: "Shangla",
  },
  {
    value: "54",
    name: "Besima",
    province_id: "1",
    province: "Balochistan",
    district_id: "47",
    district: "Kharan",
  },
  {
    value: "55",
    name: "Bhag",
    province_id: "1",
    province: "Balochistan",
    district_id: "12",
    district: "Bolan (Dhadar)",
  },
  {
    value: "56",
    name: "Bhakkar",
    province_id: "4",
    province: "Punjab",
    district_id: "11",
    district: "Bhakkar",
  },
  {
    value: "57",
    name: "Bhalwal",
    province_id: "4",
    province: "Punjab",
    district_id: "97",
    district: "Sargodha",
  },
  {
    value: "58",
    name: "Bhan",
    province_id: "5",
    province: "Sindh",
    district_id: "19",
    district: "Dadu",
  },
  {
    value: "59",
    name: "Bhawana",
    province_id: "4",
    province: "Punjab",
    district_id: "17",
    district: "Chiniot",
  },
  {
    value: "60",
    name: "Bhera",
    province_id: "4",
    province: "Punjab",
    district_id: "97",
    district: "Sargodha",
  },
  {
    value: "61",
    name: "Bhiria City",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "62",
    name: "Bhiria Road",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "63",
    name: "Bhiria Taluka",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "64",
    name: "Bhit Shah",
    province_id: "5",
    province: "Sindh",
    district_id: "70",
    district: "Matiari",
  },
  {
    value: "65",
    name: "Bhopalwala",
    province_id: "4",
    province: "Punjab",
    district_id: "102",
    district: "Sialkot",
  },
  {
    value: "66",
    name: "Bin Qasim Town",
    province_id: "5",
    province: "Sindh",
    district_id: "41",
    district: "Karachi",
  },
  {
    value: "67",
    name: "Birmal",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "104",
    district: "South Waziristan",
  },
  {
    value: "68",
    name: "Bolan (Dhadar)",
    province_id: "1",
    province: "Balochistan",
    district_id: "12",
    district: "Bolan (Dhadar)",
  },
  {
    value: "69",
    name: "Bozdar Wada",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "70",
    name: "Bucheri",
    province_id: "5",
    province: "Sindh",
    district_id: "80",
    district: "Nawabshah",
  },
  {
    value: "71",
    name: "Buleda",
    province_id: "1",
    province: "Balochistan",
    district_id: "44",
    district: "Kech(Turbat)",
  },
  {
    value: "72",
    name: "Bulri",
    province_id: "5",
    province: "Sindh",
    district_id: "32",
    district: "Hyderabad",
  },
  {
    value: "73",
    name: "Bunner",
    province_id: "3",
    province: "KPK",
    district_id: "13",
    district: "Bunner",
  },
  {
    value: "74",
    name: "Burewala",
    province_id: "4",
    province: "Punjab",
    district_id: "115",
    district: "Vehari",
  },
  {
    value: "75",
    name: "Chachro",
    province_id: "5",
    province: "Sindh",
    district_id: "110",
    district: "Tharparkar",
  },
  {
    value: "76",
    name: "Chagai",
    province_id: "1",
    province: "Balochistan",
    district_id: "14",
    district: "Chagai",
  },
  {
    value: "77",
    name: "Chak",
    province_id: "5",
    province: "Sindh",
    district_id: "101",
    district: "Shikarpur",
  },
  {
    value: "78",
    name: "Chak Jhumra",
    province_id: "4",
    province: "Punjab",
    district_id: "23",
    district: "Faisalabad",
  },
  {
    value: "79",
    name: "Chakesar",
    province_id: "3",
    province: "KPK",
    district_id: "98",
    district: "Shangla",
  },
  {
    value: "80",
    name: "Chakwal",
    province_id: "4",
    province: "Punjab",
    district_id: "15",
    district: "Chakwal",
  },
  {
    value: "81",
    name: "Chaman",
    province_id: "1",
    province: "Balochistan",
    district_id: "51",
    district: "Killa Abdullah",
  },
  {
    value: "82",
    name: "Chambar",
    province_id: "5",
    province: "Sindh",
    district_id: "32",
    district: "Hyderabad",
  },
  {
    value: "83",
    name: "Chani Goth",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "84",
    name: "Charsadda",
    province_id: "3",
    province: "KPK",
    district_id: "16",
    district: "Charsadda",
  },
  {
    value: "85",
    name: "Chashma",
    province_id: "4",
    province: "Punjab",
    district_id: "71",
    district: "Mianwali",
  },
  {
    value: "86",
    name: "Chattar",
    province_id: "1",
    province: "Balochistan",
    district_id: "78",
    district: "Nasirabad",
  },
  {
    value: "87",
    name: "Chaubara",
    province_id: "4",
    province: "Punjab",
    district_id: "61",
    district: "Layyah",
  },
  {
    value: "88",
    name: "Chawinda",
    province_id: "4",
    province: "Punjab",
    district_id: "102",
    district: "Sialkot",
  },
  {
    value: "89",
    name: "Chenab Nagar",
    province_id: "4",
    province: "Punjab",
    district_id: "38",
    district: "Jhang",
  },
  {
    value: "90",
    name: "Cherat Cantt.",
    province_id: "3",
    province: "KPK",
    district_id: "83",
    district: "Nowshera",
  },
  {
    value: "91",
    name: "Chichawatni",
    province_id: "4",
    province: "Punjab",
    district_id: "95",
    district: "Sahiwal",
  },
  {
    value: "92",
    name: "Chiniot",
    province_id: "4",
    province: "Punjab",
    district_id: "38",
    district: "Jhang",
  },
  {
    value: "93",
    name: "Chishtian",
    province_id: "4",
    province: "Punjab",
    district_id: "5",
    district: "Bahawalnagar",
  },
  {
    value: "94",
    name: "Chitkan",
    province_id: "1",
    province: "Balochistan",
    district_id: "88",
    district: "Panjgur",
  },
  {
    value: "95",
    name: "Chitral",
    province_id: "3",
    province: "KPK",
    district_id: "18",
    district: "Chitral",
  },
  {
    value: "96",
    name: "Choa Saidan Shah",
    province_id: "4",
    province: "Punjab",
    district_id: "15",
    district: "Chakwal",
  },
  {
    value: "97",
    name: "Chondko",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "98",
    name: "Choti Zareen",
    province_id: "4",
    province: "Punjab",
    district_id: "21",
    district: "Dera Ghazi Khan",
  },
  {
    value: "99",
    name: "Chowdagi",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "100",
    name: "Chowk Azam",
    province_id: "4",
    province: "Punjab",
    district_id: "61",
    district: "Layyah",
  },
  {
    value: "101",
    name: "Chowk Maitla",
    province_id: "4",
    province: "Punjab",
    district_id: "62",
    district: "Lodhran",
  },
  {
    value: "102",
    name: "Chowk Munda",
    province_id: "4",
    province: "Punjab",
    district_id: "92",
    district: "Rahim Yar Khan",
  },
  {
    value: "103",
    name: "Chowk Sarwar Shaheed",
    province_id: "4",
    province: "Punjab",
    district_id: "76",
    district: "Muzaffargarh",
  },
  {
    value: "104",
    name: "Chuhar Jamali",
    province_id: "5",
    province: "Sindh",
    district_id: "32",
    district: "Hyderabad",
  },
  {
    value: "105",
    name: "Chunian",
    province_id: "4",
    province: "Punjab",
    district_id: "43",
    district: "Kasur",
  },
  {
    value: "106",
    name: "D.I.Khan",
    province_id: "3",
    province: "KPK",
    district_id: "22",
    district: "Dera Ismail Khan",
  },
  {
    value: "107",
    name: "Dadu",
    province_id: "5",
    province: "Sindh",
    district_id: "19",
    district: "Dadu",
  },
  {
    value: "108",
    name: "Daharki",
    province_id: "5",
    province: "Sindh",
    district_id: "24",
    district: "Ghotki",
  },
  {
    value: "109",
    name: "Dahranwala",
    province_id: "4",
    province: "Punjab",
    district_id: "5",
    district: "Bahawalnagar",
  },
  {
    value: "110",
    name: "Dajal",
    province_id: "4",
    province: "Punjab",
    district_id: "93",
    district: "Rajan Pur",
  },
  {
    value: "111",
    name: "Dak Sub-Tehsil",
    province_id: "1",
    province: "Balochistan",
    district_id: "84",
    district: "Nushki",
  },
  {
    value: "112",
    name: "Dalbandin",
    province_id: "1",
    province: "Balochistan",
    district_id: "14",
    district: "Chagai",
  },
  {
    value: "113",
    name: "Daraban",
    province_id: "3",
    province: "KPK",
    district_id: "22",
    district: "Dera Ismail Khan",
  },
  {
    value: "114",
    name: "Daro",
    province_id: "5",
    province: "Sindh",
    district_id: "111",
    district: "Thatta",
  },
  {
    value: "115",
    name: "Darya Khan",
    province_id: "4",
    province: "Punjab",
    district_id: "11",
    district: "Bhakkar",
  },
  {
    value: "116",
    name: "Darya Khan Mari",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "117",
    name: "Dasht Sub-Division",
    province_id: "1",
    province: "Balochistan",
    district_id: "69",
    district: "Mastung",
  },
  {
    value: "118",
    name: "Daska",
    province_id: "4",
    province: "Punjab",
    district_id: "102",
    district: "Sialkot",
  },
  {
    value: "119",
    name: "Dassu",
    province_id: "3",
    province: "KPK",
    district_id: "54",
    district: "Kohistan",
  },
  {
    value: "120",
    name: "Datta Khel",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "82",
    district: "North Waziristan",
  },
  {
    value: "121",
    name: "Daud Khel",
    province_id: "4",
    province: "Punjab",
    district_id: "71",
    district: "Mianwali",
  },
  {
    value: "122",
    name: "Daulatpur",
    province_id: "5",
    province: "Sindh",
    district_id: "80",
    district: "Nawabshah",
  },
  {
    value: "123",
    name: "Daultala",
    province_id: "4",
    province: "Punjab",
    district_id: "94",
    district: "Rawalpindi",
  },
  {
    value: "124",
    name: "Daur",
    province_id: "5",
    province: "Sindh",
    district_id: "80",
    district: "Nawabshah",
  },
  {
    value: "125",
    name: "Depalpur",
    province_id: "4",
    province: "Punjab",
    district_id: "85",
    district: "Okara",
  },
  {
    value: "126",
    name: "Dera Allah Yar",
    province_id: "1",
    province: "Balochistan",
    district_id: "35",
    district: "Jaffarabad",
  },
  {
    value: "127",
    name: "Dera Bughti",
    province_id: "1",
    province: "Balochistan",
    district_id: "20",
    district: "Dera Bughti",
  },
  {
    value: "128",
    name: "Dera Din Panah",
    province_id: "4",
    province: "Punjab",
    district_id: "76",
    district: "Muzaffargarh",
  },
  {
    value: "129",
    name: "Dera Ghazi Khan",
    province_id: "4",
    province: "Punjab",
    district_id: "21",
    district: "Dera Ghazi Khan",
  },
  {
    value: "130",
    name: "Dera Ismail Khan",
    province_id: "3",
    province: "KPK",
    district_id: "22",
    district: "Dera Ismail Khan",
  },
  {
    value: "131",
    name: "Dera Murad Jamali",
    province_id: "1",
    province: "Balochistan",
    district_id: "78",
    district: "Nasirabad",
  },
  {
    value: "132",
    name: "Dhadar",
    province_id: "1",
    province: "Balochistan",
    district_id: "12",
    district: "Bolan (Dhadar)",
  },
  {
    value: "133",
    name: "Dhanote",
    province_id: "4",
    province: "Punjab",
    district_id: "62",
    district: "Lodhran",
  },
  {
    value: "134",
    name: "Dhonkal",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "135",
    name: "Dhoronaro",
    province_id: "5",
    province: "Sindh",
    district_id: "113",
    district: "Umarkot",
  },
  {
    value: "136",
    name: "Digri",
    province_id: "5",
    province: "Sindh",
    district_id: "72",
    district: "Mirpur Khas",
  },
  {
    value: "137",
    name: "Dij Kot",
    province_id: "4",
    province: "Punjab",
    district_id: "23",
    district: "Faisalabad",
  },
  {
    value: "138",
    name: "Dina",
    province_id: "4",
    province: "Punjab",
    district_id: "39",
    district: "Jhelum",
  },
  {
    value: "139",
    name: "Dinga",
    province_id: "4",
    province: "Punjab",
    district_id: "26",
    district: "Gujrat",
  },
  {
    value: "140",
    name: "Dipalpur",
    province_id: "4",
    province: "Punjab",
    district_id: "85",
    district: "Okara",
  },
  {
    value: "141",
    name: "Diplo",
    province_id: "5",
    province: "Sindh",
    district_id: "110",
    district: "Tharparkar",
  },
  {
    value: "142",
    name: "Dir",
    province_id: "3",
    province: "KPK",
    district_id: "114",
    district: "Upper Dir",
  },
  {
    value: "143",
    name: "Doaba",
    province_id: "3",
    province: "KPK",
    district_id: "29",
    district: "Hangu",
  },
  {
    value: "144",
    name: "Dobandi Sub-Tehsil",
    province_id: "1",
    province: "Balochistan",
    district_id: "51",
    district: "Killa Abdullah",
  },
  {
    value: "145",
    name: "Dokri",
    province_id: "5",
    province: "Sindh",
    district_id: "59",
    district: "Larkana",
  },
  {
    value: "146",
    name: "Dossali",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "82",
    district: "North Waziristan",
  },
  {
    value: "147",
    name: "Drosh",
    province_id: "3",
    province: "KPK",
    district_id: "18",
    district: "Chitral",
  },
  {
    value: "148",
    name: "Duki",
    province_id: "1",
    province: "Balochistan",
    district_id: "63",
    district: "Loralai",
  },
  {
    value: "149",
    name: "Dullewala",
    province_id: "4",
    province: "Punjab",
    district_id: "11",
    district: "Bhakkar",
  },
  {
    value: "150",
    name: "Dunga Bunga",
    province_id: "4",
    province: "Punjab",
    district_id: "5",
    district: "Bahawalnagar",
  },
  {
    value: "151",
    name: "Dunyapur",
    province_id: "4",
    province: "Punjab",
    district_id: "62",
    district: "Lodhran",
  },
  {
    value: "152",
    name: "Dureji",
    province_id: "1",
    province: "Balochistan",
    district_id: "60",
    district: "Lasbella",
  },
  {
    value: "153",
    name: "Eminabad",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "154",
    name: "Faisalabad",
    province_id: "4",
    province: "Punjab",
    district_id: "23",
    district: "Faisalabad",
  },
  {
    value: "155",
    name: "Faiz Ganj",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "156",
    name: "Faqirabad",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "157",
    name: "Faqirwali",
    province_id: "4",
    province: "Punjab",
    district_id: "5",
    district: "Bahawalnagar",
  },
  {
    value: "158",
    name: "Farooqa",
    province_id: "4",
    province: "Punjab",
    district_id: "97",
    district: "Sargodha",
  },
  {
    value: "159",
    name: "Farooqabad",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "160",
    name: "Fateh Jang",
    province_id: "4",
    province: "Punjab",
    district_id: "2",
    district: "Attock",
  },
  {
    value: "161",
    name: "Fatehpur",
    province_id: "4",
    province: "Punjab",
    district_id: "43",
    district: "Kasur",
  },
  {
    value: "162",
    name: "Fazil Pur",
    province_id: "4",
    province: "Punjab",
    district_id: "92",
    district: "Rahim Yar Khan",
  },
  {
    value: "163",
    name: "Ferozewala",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "164",
    name: "Firoza",
    province_id: "4",
    province: "Punjab",
    district_id: "92",
    district: "Rahim Yar Khan",
  },
  {
    value: "165",
    name: "Fortabbas",
    province_id: "4",
    province: "Punjab",
    district_id: "5",
    district: "Bahawalnagar",
  },
  {
    value: "166",
    name: "Gadani",
    province_id: "1",
    province: "Balochistan",
    district_id: "60",
    district: "Lasbella",
  },
  {
    value: "167",
    name: "Gaggo Mandi",
    province_id: "4",
    province: "Punjab",
    district_id: "115",
    district: "Vehari",
  },
  {
    value: "168",
    name: "Gambat",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "169",
    name: "Gandaka",
    province_id: "1",
    province: "Balochistan",
    district_id: "35",
    district: "Jaffarabad",
  },
  {
    value: "170",
    name: "Gandawah",
    province_id: "1",
    province: "Balochistan",
    district_id: "37",
    district: "Jhal Magsi",
  },
  {
    value: "171",
    name: "Garelo",
    province_id: "5",
    province: "Sindh",
    district_id: "59",
    district: "Larkana",
  },
  {
    value: "172",
    name: "Garh Maharaja",
    province_id: "4",
    province: "Punjab",
    district_id: "38",
    district: "Jhang",
  },
  {
    value: "173",
    name: "Garh More",
    province_id: "4",
    province: "Punjab",
    district_id: "38",
    district: "Jhang",
  },
  {
    value: "174",
    name: "Garhi Khairo",
    province_id: "5",
    province: "Sindh",
    district_id: "34",
    district: "Jacobabad",
  },
  {
    value: "175",
    name: "Garhi Yasin",
    province_id: "5",
    province: "Sindh",
    district_id: "101",
    district: "Shikarpur",
  },
  {
    value: "176",
    name: "Garyum",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "82",
    district: "North Waziristan",
  },
  {
    value: "177",
    name: "Ghakkar",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "178",
    name: "Gharo",
    province_id: "5",
    province: "Sindh",
    district_id: "111",
    district: "Thatta",
  },
  {
    value: "179",
    name: "Ghauspur",
    province_id: "5",
    province: "Sindh",
    district_id: "34",
    district: "Jacobabad",
  },
  {
    value: "180",
    name: "Ghazi",
    province_id: "3",
    province: "KPK",
    district_id: "30",
    district: "Haripur",
  },
  {
    value: "181",
    name: "Ghazi Ghat",
    province_id: "4",
    province: "Punjab",
    district_id: "21",
    district: "Dera Ghazi Khan",
  },
  {
    value: "182",
    name: "Ghaziabad",
    province_id: "4",
    province: "Punjab",
    district_id: "95",
    district: "Sahiwal",
  },
  {
    value: "183",
    name: "Ghorabari",
    province_id: "5",
    province: "Sindh",
    district_id: "111",
    district: "Thatta",
  },
  {
    value: "184",
    name: "Ghotki",
    province_id: "5",
    province: "Sindh",
    district_id: "24",
    district: "Ghotki",
  },
  {
    value: "185",
    name: "Ghulam Khan",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "82",
    district: "North Waziristan",
  },
  {
    value: "186",
    name: "Ghurgushti",
    province_id: "4",
    province: "Punjab",
    district_id: "2",
    district: "Attock",
  },
  {
    value: "187",
    name: "Gichk",
    province_id: "1",
    province: "Balochistan",
    district_id: "88",
    district: "Panjgur",
  },
  {
    value: "188",
    name: "Gojra",
    province_id: "4",
    province: "Punjab",
    district_id: "112",
    district: "Toba Tek Singh",
  },
  {
    value: "189",
    name: "Golarchi Taluka",
    province_id: "5",
    province: "Sindh",
    district_id: "4",
    district: "Badin",
  },
  {
    value: "190",
    name: "Gujar Khan",
    province_id: "4",
    province: "Punjab",
    district_id: "94",
    district: "Rawalpindi",
  },
  {
    value: "191",
    name: "Gujranwala",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "192",
    name: "GUJRAT",
    province_id: "4",
    province: "Punjab",
    district_id: "26",
    district: "Gujrat",
  },
  {
    value: "193",
    name: "Gulistan",
    province_id: "1",
    province: "Balochistan",
    district_id: "51",
    district: "Killa Abdullah",
  },
  {
    value: "194",
    name: "Gupchani",
    province_id: "5",
    province: "Sindh",
    district_id: "80",
    district: "Nawabshah",
  },
  {
    value: "195",
    name: "Gwadar",
    province_id: "1",
    province: "Balochistan",
    district_id: "27",
    district: "Gwadar",
  },
  {
    value: "196",
    name: "Hadali",
    province_id: "4",
    province: "Punjab",
    district_id: "48",
    district: "Khushab",
  },
  {
    value: "197",
    name: "Hafizabad",
    province_id: "4",
    province: "Punjab",
    district_id: "28",
    district: "Hafizabad",
  },
  {
    value: "198",
    name: "Hala",
    province_id: "5",
    province: "Sindh",
    district_id: "70",
    district: "Matiari",
  },
  {
    value: "199",
    name: "Halani",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "200",
    name: "Halimzai",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "73",
    district: "Mohmand Agency",
  },
  {
    value: "201",
    name: "Hangu",
    province_id: "3",
    province: "KPK",
    district_id: "29",
    district: "Hangu",
  },
  {
    value: "202",
    name: "Haripur",
    province_id: "3",
    province: "KPK",
    district_id: "30",
    district: "Haripur",
  },
  {
    value: "203",
    name: "Harnai",
    province_id: "1",
    province: "Balochistan",
    district_id: "31",
    district: "Harnai",
  },
  {
    value: "204",
    name: "Harnoli",
    province_id: "4",
    province: "Punjab",
    district_id: "71",
    district: "Mianwali",
  },
  {
    value: "205",
    name: "Haroonabad",
    province_id: "4",
    province: "Punjab",
    district_id: "5",
    district: "Bahawalnagar",
  },
  {
    value: "206",
    name: "Hasan Abdal",
    province_id: "4",
    province: "Punjab",
    district_id: "2",
    district: "Attock",
  },
  {
    value: "207",
    name: "Hasilpur",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "208",
    name: "Havelian",
    province_id: "3",
    province: "KPK",
    district_id: "1",
    district: "Abbottabad",
  },
  {
    value: "209",
    name: "Hazro",
    province_id: "4",
    province: "Punjab",
    district_id: "2",
    district: "Attock",
  },
  {
    value: "210",
    name: "Head Bakkani",
    province_id: "4",
    province: "Punjab",
    district_id: "76",
    district: "Muzaffargarh",
  },
  {
    value: "211",
    name: "Head Rajkan",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "212",
    name: "Hingorja",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "213",
    name: "Hoshab",
    province_id: "1",
    province: "Balochistan",
    district_id: "44",
    district: "Kech(Turbat)",
  },
  {
    value: "214",
    name: "Hub",
    province_id: "1",
    province: "Balochistan",
    district_id: "60",
    district: "Lasbella",
  },
  {
    value: "215",
    name: "Hujra Shah Muqeem",
    province_id: "4",
    province: "Punjab",
    district_id: "85",
    district: "Okara",
  },
  {
    value: "216",
    name: "Hurramzai Sub-Tehsil",
    province_id: "1",
    province: "Balochistan",
    district_id: "90",
    district: "Pishin",
  },
  {
    value: "217",
    name: "Hyderabad",
    province_id: "5",
    province: "Sindh",
    district_id: "32",
    district: "Hyderabad",
  },
  {
    value: "218",
    name: "Iqbal Nagar",
    province_id: "4",
    province: "Punjab",
    district_id: "95",
    district: "Sahiwal",
  },
  {
    value: "219",
    name: "Isa khel",
    province_id: "4",
    province: "Punjab",
    district_id: "71",
    district: "Mianwali",
  },
  {
    value: "220",
    name: "Islamabad",
    province_id: "4",
    province: "Punjab",
    district_id: "33",
    district: "Islamabad",
  },
  {
    value: "221",
    name: "Jacobabad",
    province_id: "5",
    province: "Sindh",
    district_id: "34",
    district: "Jacobabad",
  },
  {
    value: "222",
    name: "Jaffarabad",
    province_id: "1",
    province: "Balochistan",
    district_id: "35",
    district: "Jaffarabad",
  },
  {
    value: "223",
    name: "Jalalpur Bhattian",
    province_id: "4",
    province: "Punjab",
    district_id: "28",
    district: "Hafizabad",
  },
  {
    value: "224",
    name: "Jalalpur Jattan",
    province_id: "4",
    province: "Punjab",
    district_id: "26",
    district: "Gujrat",
  },
  {
    value: "225",
    name: "Jalalpur Pirwala",
    province_id: "4",
    province: "Punjab",
    district_id: "74",
    district: "Multan",
  },
  {
    value: "226",
    name: "Jalalpur Sharif",
    province_id: "4",
    province: "Punjab",
    district_id: "39",
    district: "Jhelum",
  },
  {
    value: "227",
    name: "Jalla Jeem",
    province_id: "4",
    province: "Punjab",
    district_id: "115",
    district: "Vehari",
  },
  {
    value: "228",
    name: "Jam Nawaz Ali",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "229",
    name: "Jam Sahib",
    province_id: "5",
    province: "Sindh",
    district_id: "80",
    district: "Nawabshah",
  },
  {
    value: "230",
    name: "Jamke Cheema",
    province_id: "4",
    province: "Punjab",
    district_id: "102",
    district: "Sialkot",
  },
  {
    value: "231",
    name: "Jampur",
    province_id: "4",
    province: "Punjab",
    district_id: "93",
    district: "Rajan Pur",
  },
  {
    value: "232",
    name: "Jamrud",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "50",
    district: "Khyber Agency",
  },
  {
    value: "233",
    name: "Jand",
    province_id: "4",
    province: "Punjab",
    district_id: "2",
    district: "Attock",
  },
  {
    value: "234",
    name: "Jandiala Sher Khan",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "235",
    name: "Janpur",
    province_id: "4",
    province: "Punjab",
    district_id: "93",
    district: "Rajan Pur",
  },
  {
    value: "236",
    name: "Jaranwala",
    province_id: "4",
    province: "Punjab",
    district_id: "23",
    district: "Faisalabad",
  },
  {
    value: "237",
    name: "Jati",
    province_id: "5",
    province: "Sindh",
    district_id: "111",
    district: "Thatta",
  },
  {
    value: "238",
    name: "Jatoi",
    province_id: "4",
    province: "Punjab",
    district_id: "76",
    district: "Muzaffargarh",
  },
  {
    value: "239",
    name: "Jauhrabad",
    province_id: "4",
    province: "Punjab",
    district_id: "48",
    district: "Khushab",
  },
  {
    value: "240",
    name: "Jehangira",
    province_id: "3",
    province: "KPK",
    district_id: "106",
    district: "Swabi",
  },
  {
    value: "241",
    name: "Jehanian",
    province_id: "4",
    province: "Punjab",
    district_id: "46",
    district: "Khanewal",
  },
  {
    value: "242",
    name: "Jhal Jao",
    province_id: "1",
    province: "Balochistan",
    district_id: "3",
    district: "Awaran",
  },
  {
    value: "243",
    name: "Jhal Magsi",
    province_id: "1",
    province: "Balochistan",
    district_id: "37",
    district: "Jhal Magsi",
  },
  {
    value: "244",
    name: "Jhang",
    province_id: "4",
    province: "Punjab",
    district_id: "38",
    district: "Jhang",
  },
  {
    value: "245",
    name: "Jhat Pat",
    province_id: "1",
    province: "Balochistan",
    district_id: "35",
    district: "Jaffarabad",
  },
  {
    value: "246",
    name: "Jhawarian",
    province_id: "4",
    province: "Punjab",
    district_id: "97",
    district: "Sargodha",
  },
  {
    value: "247",
    name: "Jhelum",
    province_id: "4",
    province: "Punjab",
    district_id: "39",
    district: "Jhelum",
  },
  {
    value: "248",
    name: "Jhol",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "249",
    name: "Jhudo",
    province_id: "5",
    province: "Sindh",
    district_id: "72",
    district: "Mirpur Khas",
  },
  {
    value: "250",
    name: "Jiwani",
    province_id: "1",
    province: "Balochistan",
    district_id: "27",
    district: "Gwadar",
  },
  {
    value: "251",
    name: "Johi",
    province_id: "5",
    province: "Sindh",
    district_id: "19",
    district: "Dadu",
  },
  {
    value: "252",
    name: "Kabirwala",
    province_id: "4",
    province: "Punjab",
    district_id: "46",
    district: "Khanewal",
  },
  {
    value: "253",
    name: "Kacha Khuh",
    province_id: "4",
    province: "Punjab",
    district_id: "46",
    district: "Khanewal",
  },
  {
    value: "254",
    name: "Kadhan",
    province_id: "5",
    province: "Sindh",
    district_id: "4",
    district: "Badin",
  },
  {
    value: "255",
    name: "Kahan",
    province_id: "1",
    province: "Balochistan",
    district_id: "55",
    district: "Kohlu",
  },
  {
    value: "256",
    name: "Kahror Pacca",
    province_id: "4",
    province: "Punjab",
    district_id: "62",
    district: "Lodhran",
  },
  {
    value: "257",
    name: "Kahuta",
    province_id: "4",
    province: "Punjab",
    district_id: "94",
    district: "Rawalpindi",
  },
  {
    value: "258",
    name: "Kakar Khurasan",
    province_id: "1",
    province: "Balochistan",
    district_id: "116",
    district: "Zhob",
  },
  {
    value: "259",
    name: "Kalabagh",
    province_id: "4",
    province: "Punjab",
    district_id: "71",
    district: "Mianwali",
  },
  {
    value: "260",
    name: "Kalaswala",
    province_id: "4",
    province: "Punjab",
    district_id: "102",
    district: "Sialkot",
  },
  {
    value: "261",
    name: "Kalat",
    province_id: "1",
    province: "Balochistan",
    district_id: "40",
    district: "Kalat",
  },
  {
    value: "262",
    name: "Kaleke",
    province_id: "4",
    province: "Punjab",
    district_id: "28",
    district: "Hafizabad",
  },
  {
    value: "263",
    name: "Kallar Kahar",
    province_id: "4",
    province: "Punjab",
    district_id: "15",
    district: "Chakwal",
  },
  {
    value: "264",
    name: "Kallar Sayyadan",
    province_id: "4",
    province: "Punjab",
    district_id: "94",
    district: "Rawalpindi",
  },
  {
    value: "265",
    name: "Kalur Kot",
    province_id: "4",
    province: "Punjab",
    district_id: "11",
    district: "Bhakkar",
  },
  {
    value: "266",
    name: "Kamalia",
    province_id: "4",
    province: "Punjab",
    district_id: "112",
    district: "Toba Tek Singh",
  },
  {
    value: "267",
    name: "Kamar Mashani",
    province_id: "4",
    province: "Punjab",
    district_id: "71",
    district: "Mianwali",
  },
  {
    value: "268",
    name: "Kambar Ali Khan",
    province_id: "5",
    province: "Sindh",
    district_id: "59",
    district: "Larkana",
  },
  {
    value: "269",
    name: "Kamir",
    province_id: "4",
    province: "Punjab",
    district_id: "95",
    district: "Sahiwal",
  },
  {
    value: "270",
    name: "Kamoki",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "271",
    name: "Kandhkot",
    province_id: "5",
    province: "Sindh",
    district_id: "34",
    district: "Jacobabad",
  },
  {
    value: "272",
    name: "Kandhra",
    province_id: "5",
    province: "Sindh",
    district_id: "105",
    district: "Sukkur",
  },
  {
    value: "273",
    name: "Kandiari",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "274",
    name: "Kandiaro",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "275",
    name: "Kanganpur",
    province_id: "4",
    province: "Punjab",
    district_id: "43",
    district: "Kasur",
  },
  {
    value: "276",
    name: "Kanraj",
    province_id: "1",
    province: "Balochistan",
    district_id: "60",
    district: "Lasbella",
  },
  {
    value: "277",
    name: "Karachi",
    province_id: "5",
    province: "Sindh",
    district_id: "41",
    district: "Karachi",
  },
  {
    value: "278",
    name: "Karak",
    province_id: "3",
    province: "KPK",
    district_id: "42",
    district: "Karak",
  },
  {
    value: "279",
    name: "Karakh",
    province_id: "1",
    province: "Balochistan",
    district_id: "49",
    district: "Khuzdar",
  },
  {
    value: "280",
    name: "Karam Pur",
    province_id: "4",
    province: "Punjab",
    district_id: "115",
    district: "Vehari",
  },
  {
    value: "281",
    name: "Karezat",
    province_id: "1",
    province: "Balochistan",
    district_id: "90",
    district: "Pishin",
  },
  {
    value: "282",
    name: "Kario Ghanwar",
    province_id: "5",
    province: "Sindh",
    district_id: "4",
    district: "Badin",
  },
  {
    value: "283",
    name: "Karoondi",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "284",
    name: "Karor Lal Esan",
    province_id: "4",
    province: "Punjab",
    district_id: "61",
    district: "Layyah",
  },
  {
    value: "285",
    name: "Kashmor",
    province_id: "5",
    province: "Sindh",
    district_id: "34",
    district: "Jacobabad",
  },
  {
    value: "286",
    name: "Kassowal",
    province_id: "4",
    province: "Punjab",
    district_id: "95",
    district: "Sahiwal",
  },
  {
    value: "287",
    name: "Kasur",
    province_id: "4",
    province: "Punjab",
    district_id: "43",
    district: "Kasur",
  },
  {
    value: "288",
    name: "Kech",
    province_id: "1",
    province: "Balochistan",
    district_id: "44",
    district: "Kech(Turbat)",
  },
  {
    value: "289",
    name: "Keti Bunder",
    province_id: "5",
    province: "Sindh",
    district_id: "111",
    district: "Thatta",
  },
  {
    value: "290",
    name: "Khad Koocha",
    province_id: "1",
    province: "Balochistan",
    district_id: "69",
    district: "Mastung",
  },
  {
    value: "291",
    name: "Khadro",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "292",
    name: "Khairpur",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "293",
    name: "Khairpur Nathan Shah",
    province_id: "5",
    province: "Sindh",
    district_id: "19",
    district: "Dadu",
  },
  {
    value: "294",
    name: "Khairpur Tamewali",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "295",
    name: "Khalabat",
    province_id: "3",
    province: "KPK",
    district_id: "30",
    district: "Haripur",
  },
  {
    value: "296",
    name: "Khando",
    province_id: "5",
    province: "Sindh",
    district_id: "70",
    district: "Matiari",
  },
  {
    value: "297",
    name: "Khanewal",
    province_id: "4",
    province: "Punjab",
    district_id: "46",
    district: "Khanewal",
  },
  {
    value: "298",
    name: "Khangarh",
    province_id: "4",
    province: "Punjab",
    district_id: "76",
    district: "Muzaffargarh",
  },
  {
    value: "299",
    name: "Khanpur",
    province_id: "4",
    province: "Punjab",
    district_id: "92",
    district: "Rahim Yar Khan",
  },
  {
    value: "300",
    name: "Khanpur Mahar",
    province_id: "5",
    province: "Sindh",
    district_id: "24",
    district: "Ghotki",
  },
  {
    value: "301",
    name: "Khanqah Dogran",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "302",
    name: "Khar Bajaur",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "7",
    district: "Bajaur Agency",
  },
  {
    value: "303",
    name: "Kharan",
    province_id: "1",
    province: "Balochistan",
    district_id: "47",
    district: "Kharan",
  },
  {
    value: "304",
    name: "Kharian",
    province_id: "4",
    province: "Punjab",
    district_id: "26",
    district: "Gujrat",
  },
  {
    value: "305",
    name: "Kharo Chan",
    province_id: "5",
    province: "Sindh",
    district_id: "111",
    district: "Thatta",
  },
  {
    value: "306",
    name: "Khewra",
    province_id: "4",
    province: "Punjab",
    district_id: "39",
    district: "Jhelum",
  },
  {
    value: "307",
    name: "Khichi Wala",
    province_id: "4",
    province: "Punjab",
    district_id: "5",
    district: "Bahawalnagar",
  },
  {
    value: "308",
    name: "Khider Wala",
    province_id: "4",
    province: "Punjab",
    district_id: "23",
    district: "Faisalabad",
  },
  {
    value: "309",
    name: "Khipro",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "310",
    name: "Khoski",
    province_id: "5",
    province: "Sindh",
    district_id: "4",
    district: "Badin",
  },
  {
    value: "311",
    name: "Khudian",
    province_id: "4",
    province: "Punjab",
    district_id: "43",
    district: "Kasur",
  },
  {
    value: "312",
    name: "Khuhra",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "313",
    name: "Khurianwala",
    province_id: "4",
    province: "Punjab",
    district_id: "23",
    district: "Faisalabad",
  },
  {
    value: "314",
    name: "Khushab",
    province_id: "4",
    province: "Punjab",
    district_id: "48",
    district: "Khushab",
  },
  {
    value: "315",
    name: "Khuzdar",
    province_id: "1",
    province: "Balochistan",
    district_id: "40",
    district: "Kalat",
  },
  {
    value: "316",
    name: "Khuzdar Sub-Division",
    province_id: "1",
    province: "Balochistan",
    district_id: "49",
    district: "Khuzdar",
  },
  {
    value: "317",
    name: "Killa Abdullah",
    province_id: "1",
    province: "Balochistan",
    district_id: "51",
    district: "Killa Abdullah",
  },
  {
    value: "318",
    name: "Killa Saifullah",
    province_id: "1",
    province: "Balochistan",
    district_id: "52",
    district: "Killa Saifullah",
  },
  {
    value: "319",
    name: "Kingri",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "320",
    name: "Kirdgap",
    province_id: "1",
    province: "Balochistan",
    district_id: "69",
    district: "Mastung",
  },
  {
    value: "321",
    name: "Kohat",
    province_id: "3",
    province: "KPK",
    district_id: "53",
    district: "Kohat",
  },
  {
    value: "322",
    name: "Kohistan",
    province_id: "3",
    province: "KPK",
    district_id: "54",
    district: "Kohistan",
  },
  {
    value: "323",
    name: "Kohlu",
    province_id: "1",
    province: "Balochistan",
    district_id: "55",
    district: "Kohlu",
  },
  {
    value: "324",
    name: "Kot Abdul Malik",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "325",
    name: "Kot Addu",
    province_id: "4",
    province: "Punjab",
    district_id: "76",
    district: "Muzaffargarh",
  },
  {
    value: "326",
    name: "Kot Banglo",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "327",
    name: "Kot Diji",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "328",
    name: "Kot Ghulam Muhammad",
    province_id: "5",
    province: "Sindh",
    district_id: "81",
    district: "New Mirpur",
  },
  {
    value: "329",
    name: "Kot Lalu",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "330",
    name: "Kot Mithan",
    province_id: "4",
    province: "Punjab",
    district_id: "93",
    district: "Rajan Pur",
  },
  {
    value: "331",
    name: "Kot Momin",
    province_id: "4",
    province: "Punjab",
    district_id: "97",
    district: "Sargodha",
  },
  {
    value: "332",
    name: "Kot Radha Kishan",
    province_id: "4",
    province: "Punjab",
    district_id: "43",
    district: "Kasur",
  },
  {
    value: "333",
    name: "Kot Sabzal",
    province_id: "4",
    province: "Punjab",
    district_id: "92",
    district: "Rahim Yar Khan",
  },
  {
    value: "334",
    name: "Kot Samaba",
    province_id: "4",
    province: "Punjab",
    district_id: "92",
    district: "Rahim Yar Khan",
  },
  {
    value: "335",
    name: "Kotla Musa Khan",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "336",
    name: "Kotli Loharan",
    province_id: "4",
    province: "Punjab",
    district_id: "102",
    district: "Sialkot",
  },
  {
    value: "337",
    name: "Kotli Sattian",
    province_id: "4",
    province: "Punjab",
    district_id: "94",
    district: "Rawalpindi",
  },
  {
    value: "338",
    name: "Kotri",
    province_id: "5",
    province: "Sindh",
    district_id: "36",
    district: "Jamshoro",
  },
  {
    value: "339",
    name: "Kotri Kabir",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "340",
    name: "Kulachi",
    province_id: "3",
    province: "KPK",
    district_id: "22",
    district: "Dera Ismail Khan",
  },
  {
    value: "341",
    name: "Kumb",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "342",
    name: "Kundian",
    province_id: "4",
    province: "Punjab",
    district_id: "71",
    district: "Mianwali",
  },
  {
    value: "343",
    name: "Kunjah",
    province_id: "4",
    province: "Punjab",
    district_id: "26",
    district: "Gujrat",
  },
  {
    value: "344",
    name: "Kunri",
    province_id: "5",
    province: "Sindh",
    district_id: "113",
    district: "Umarkot",
  },
  {
    value: "345",
    name: "Lachi",
    province_id: "3",
    province: "KPK",
    district_id: "53",
    district: "Kohat",
  },
  {
    value: "346",
    name: "Ladha",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "104",
    district: "South Waziristan",
  },
  {
    value: "347",
    name: "Lahor",
    province_id: "3",
    province: "KPK",
    district_id: "106",
    district: "Swabi",
  },
  {
    value: "348",
    name: "Lakhi",
    province_id: "5",
    province: "Sindh",
    district_id: "101",
    district: "Shikarpur",
  },
  {
    value: "349",
    name: "Lakhra",
    province_id: "1",
    province: "Balochistan",
    district_id: "60",
    district: "Lasbella",
  },
  {
    value: "350",
    name: "Lakki Marwat",
    province_id: "3",
    province: "KPK",
    district_id: "58",
    district: "Lakki Marwat",
  },
  {
    value: "351",
    name: "Lala Musa",
    province_id: "4",
    province: "Punjab",
    district_id: "26",
    district: "Gujrat",
  },
  {
    value: "352",
    name: "Lalian",
    province_id: "4",
    province: "Punjab",
    district_id: "38",
    district: "Jhang",
  },
  {
    value: "353",
    name: "Landi Kotal",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "50",
    district: "Khyber Agency",
  },
  {
    value: "354",
    name: "Larkana",
    province_id: "5",
    province: "Sindh",
    district_id: "59",
    district: "Larkana",
  },
  {
    value: "355",
    name: "Lasbela",
    province_id: "1",
    province: "Balochistan",
    district_id: "60",
    district: "Lasbella",
  },
  {
    value: "356",
    name: "Layyah",
    province_id: "4",
    province: "Punjab",
    district_id: "61",
    district: "Layyah",
  },
  {
    value: "357",
    name: "Liaqatpur",
    province_id: "4",
    province: "Punjab",
    district_id: "92",
    district: "Rahim Yar Khan",
  },
  {
    value: "358",
    name: "Liaquatabad (Piplan)",
    province_id: "4",
    province: "Punjab",
    district_id: "71",
    district: "Mianwali",
  },
  {
    value: "359",
    name: "Liari Sub-Tehsil",
    province_id: "1",
    province: "Balochistan",
    district_id: "60",
    district: "Lasbella",
  },
  {
    value: "360",
    name: "Lilliani",
    province_id: "4",
    province: "Punjab",
    district_id: "97",
    district: "Sargodha",
  },
  {
    value: "361",
    name: "Lodhran",
    province_id: "4",
    province: "Punjab",
    district_id: "62",
    district: "Lodhran",
  },
  {
    value: "362",
    name: "Loi Band Tehsil",
    province_id: "1",
    province: "Balochistan",
    district_id: "52",
    district: "Killa Saifullah",
  },
  {
    value: "363",
    name: "Loralai",
    province_id: "1",
    province: "Balochistan",
    district_id: "63",
    district: "Loralai",
  },
  {
    value: "364",
    name: "Loti",
    province_id: "1",
    province: "Balochistan",
    district_id: "20",
    district: "Dera Bughti",
  },
  {
    value: "365",
    name: "Lower",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "86",
    district: "Orakzai Agency",
  },
  {
    value: "366",
    name: "Lower Kurram",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "56",
    district: "Kurram Agency",
  },
  {
    value: "367",
    name: "Luddan",
    province_id: "4",
    province: "Punjab",
    district_id: "115",
    district: "Vehari",
  },
  {
    value: "368",
    name: "Ludhewala Warraich",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "369",
    name: "Mach",
    province_id: "1",
    province: "Balochistan",
    district_id: "12",
    district: "Bolan (Dhadar)",
  },
  {
    value: "370",
    name: "Madeji",
    province_id: "5",
    province: "Sindh",
    district_id: "101",
    district: "Shikarpur",
  },
  {
    value: "371",
    name: "Madrassa",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "372",
    name: "Mailsi",
    province_id: "4",
    province: "Punjab",
    district_id: "115",
    district: "Vehari",
  },
  {
    value: "373",
    name: "Makhdoom Pur Pahoran",
    province_id: "4",
    province: "Punjab",
    district_id: "46",
    district: "Khanewal",
  },
  {
    value: "374",
    name: "Malakand",
    province_id: "3",
    province: "KPK",
    district_id: "65",
    district: "Malakand",
  },
  {
    value: "375",
    name: "Malakwal",
    province_id: "4",
    province: "Punjab",
    district_id: "66",
    district: "Mandi Bahauddin",
  },
  {
    value: "376",
    name: "Mamu kanjan",
    province_id: "4",
    province: "Punjab",
    district_id: "23",
    district: "Faisalabad",
  },
  {
    value: "377",
    name: "Mamund",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "7",
    district: "Bajaur Agency",
  },
  {
    value: "378",
    name: "Mand Sub-Tehsil",
    province_id: "1",
    province: "Balochistan",
    district_id: "44",
    district: "Kech(Turbat)",
  },
  {
    value: "379",
    name: "Mandi Bahauddin",
    province_id: "4",
    province: "Punjab",
    district_id: "66",
    district: "Mandi Bahauddin",
  },
  {
    value: "380",
    name: "Mandi Sadiq Ganj",
    province_id: "4",
    province: "Punjab",
    district_id: "5",
    district: "Bahawalnagar",
  },
  {
    value: "381",
    name: "Mando Dero",
    province_id: "5",
    province: "Sindh",
    district_id: "105",
    district: "Sukkur",
  },
  {
    value: "382",
    name: "Mangat",
    province_id: "4",
    province: "Punjab",
    district_id: "66",
    district: "Mandi Bahauddin",
  },
  {
    value: "383",
    name: "Mangla Cantt.",
    province_id: "4",
    province: "Punjab",
    district_id: "39",
    district: "Jhelum",
  },
  {
    value: "384",
    name: "Mankera",
    province_id: "4",
    province: "Punjab",
    district_id: "11",
    district: "Bhakkar",
  },
  {
    value: "385",
    name: "Mansehra",
    province_id: "3",
    province: "KPK",
    district_id: "67",
    district: "Mansehra",
  },
  {
    value: "386",
    name: "Maqsoodo Rind",
    province_id: "5",
    province: "Sindh",
    district_id: "80",
    district: "Nawabshah",
  },
  {
    value: "387",
    name: "Mardan",
    province_id: "3",
    province: "KPK",
    district_id: "68",
    district: "Mardan",
  },
  {
    value: "388",
    name: "Marot",
    province_id: "4",
    province: "Punjab",
    district_id: "5",
    district: "Bahawalnagar",
  },
  {
    value: "389",
    name: "Martoong",
    province_id: "3",
    province: "KPK",
    district_id: "98",
    district: "Shangla",
  },
  {
    value: "390",
    name: "Mashkai",
    province_id: "1",
    province: "Balochistan",
    district_id: "3",
    district: "Awaran",
  },
  {
    value: "391",
    name: "Mashkhel",
    province_id: "1",
    province: "Balochistan",
    district_id: "47",
    district: "Kharan",
  },
  {
    value: "392",
    name: "Mastuj",
    province_id: "3",
    province: "KPK",
    district_id: "18",
    district: "Chitral",
  },
  {
    value: "393",
    name: "Mastung",
    province_id: "1",
    province: "Balochistan",
    district_id: "69",
    district: "Mastung",
  },
  {
    value: "394",
    name: "Matiari",
    province_id: "5",
    province: "Sindh",
    district_id: "70",
    district: "Matiari",
  },
  {
    value: "395",
    name: "Matli",
    province_id: "5",
    province: "Sindh",
    district_id: "4",
    district: "Badin",
  },
  {
    value: "396",
    name: "Matta",
    province_id: "3",
    province: "KPK",
    district_id: "107",
    district: "Swat",
  },
  {
    value: "397",
    name: "Mawand",
    province_id: "1",
    province: "Balochistan",
    district_id: "55",
    district: "Kohlu",
  },
  {
    value: "398",
    name: "Mehar",
    province_id: "5",
    province: "Sindh",
    district_id: "19",
    district: "Dadu",
  },
  {
    value: "399",
    name: "Mehrabpur",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "400",
    name: "Mekhtar",
    province_id: "1",
    province: "Balochistan",
    district_id: "63",
    district: "Loralai",
  },
  {
    value: "401",
    name: "Mian Channu",
    province_id: "4",
    province: "Punjab",
    district_id: "46",
    district: "Khanewal",
  },
  {
    value: "402",
    name: "Miani",
    province_id: "4",
    province: "Punjab",
    district_id: "97",
    district: "Sargodha",
  },
  {
    value: "403",
    name: "Mianwali",
    province_id: "4",
    province: "Punjab",
    district_id: "71",
    district: "Mianwali",
  },
  {
    value: "404",
    name: "Minchinabad",
    province_id: "4",
    province: "Punjab",
    district_id: "5",
    district: "Bahawalnagar",
  },
  {
    value: "405",
    name: "Mingora",
    province_id: "3",
    province: "KPK",
    district_id: "107",
    district: "Swat",
  },
  {
    value: "406",
    name: "Mir Ali",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "82",
    district: "North Waziristan",
  },
  {
    value: "407",
    name: "Mir Shah",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "82",
    district: "North Waziristan",
  },
  {
    value: "408",
    name: "Miro Khan",
    province_id: "5",
    province: "Sindh",
    district_id: "59",
    district: "Larkana",
  },
  {
    value: "409",
    name: "Mirpur Batharo",
    province_id: "5",
    province: "Sindh",
    district_id: "111",
    district: "Thatta",
  },
  {
    value: "410",
    name: "Mirpur Khas",
    province_id: "5",
    province: "Sindh",
    district_id: "72",
    district: "Mirpur Khas",
  },
  {
    value: "411",
    name: "Mirpur Mathelo",
    province_id: "5",
    province: "Sindh",
    district_id: "24",
    district: "Ghotki",
  },
  {
    value: "412",
    name: "Mirpur Sakro",
    province_id: "5",
    province: "Sindh",
    district_id: "111",
    district: "Thatta",
  },
  {
    value: "413",
    name: "Mitha Tiwana",
    province_id: "4",
    province: "Punjab",
    district_id: "48",
    district: "Khushab",
  },
  {
    value: "414",
    name: "Mithi",
    province_id: "5",
    province: "Sindh",
    district_id: "110",
    district: "Tharparkar",
  },
  {
    value: "415",
    name: "Mitro",
    province_id: "4",
    province: "Punjab",
    district_id: "115",
    district: "Vehari",
  },
  {
    value: "416",
    name: "Mohenjo-daro",
    province_id: "5",
    province: "Sindh",
    district_id: "59",
    district: "Larkana",
  },
  {
    value: "417",
    name: "Mongi Bangla",
    province_id: "4",
    province: "Punjab",
    district_id: "112",
    district: "Toba Tek Singh",
  },
  {
    value: "418",
    name: "Moro",
    province_id: "5",
    province: "Sindh",
    district_id: "105",
    district: "Sukkur",
  },
  {
    value: "419",
    name: "Muhammadpur Dewan",
    province_id: "4",
    province: "Punjab",
    district_id: "93",
    district: "Rajan Pur",
  },
  {
    value: "420",
    name: "Multan",
    province_id: "4",
    province: "Punjab",
    district_id: "74",
    district: "Multan",
  },
  {
    value: "421",
    name: "Mureed Wala",
    province_id: "4",
    province: "Punjab",
    district_id: "93",
    district: "Rajan Pur",
  },
  {
    value: "422",
    name: "Muridke",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "423",
    name: "Murree",
    province_id: "4",
    province: "Punjab",
    district_id: "94",
    district: "Rawalpindi",
  },
  {
    value: "424",
    name: "Musakhel",
    province_id: "1",
    province: "Balochistan",
    district_id: "75",
    district: "Musakhel",
  },
  {
    value: "425",
    name: "Mustafaabad",
    province_id: "4",
    province: "Punjab",
    district_id: "43",
    district: "Kasur",
  },
  {
    value: "426",
    name: "Muzaffargarh",
    province_id: "4",
    province: "Punjab",
    district_id: "76",
    district: "Muzaffargarh",
  },
  {
    value: "427",
    name: "Nabisar",
    province_id: "5",
    province: "Sindh",
    district_id: "72",
    district: "Mirpur Khas",
  },
  {
    value: "428",
    name: "Nagar Parkar Taluka",
    province_id: "5",
    province: "Sindh",
    district_id: "110",
    district: "Tharparkar",
  },
  {
    value: "429",
    name: "Nal",
    province_id: "1",
    province: "Balochistan",
    district_id: "49",
    district: "Khuzdar",
  },
  {
    value: "430",
    name: "Nankana Sahib",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "431",
    name: "Nara Taluka",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "432",
    name: "Narang",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "433",
    name: "Narowal",
    province_id: "4",
    province: "Punjab",
    district_id: "77",
    district: "Narowal",
  },
  {
    value: "434",
    name: "Nasirabad",
    province_id: "5",
    province: "Sindh",
    district_id: "59",
    district: "Larkana",
  },
  {
    value: "435",
    name: "Nauabad",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "436",
    name: "Naudero",
    province_id: "5",
    province: "Sindh",
    district_id: "59",
    district: "Larkana",
  },
  {
    value: "437",
    name: "Naukot",
    province_id: "5",
    province: "Sindh",
    district_id: "110",
    district: "Tharparkar",
  },
  {
    value: "438",
    name: "Naurang",
    province_id: "3",
    province: "KPK",
    district_id: "58",
    district: "Lakki Marwat",
  },
  {
    value: "439",
    name: "Naushahro Feroze",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "440",
    name: "Nawab Shah",
    province_id: "5",
    province: "Sindh",
    district_id: "80",
    district: "Nawabshah",
  },
  {
    value: "441",
    name: "Nawagai",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "7",
    district: "Bajaur Agency",
  },
  {
    value: "442",
    name: "Nawan Jandanwala",
    province_id: "4",
    province: "Punjab",
    district_id: "11",
    district: "Bhakkar",
  },
  {
    value: "443",
    name: "Nawansher",
    province_id: "3",
    province: "KPK",
    district_id: "1",
    district: "Abbottabad",
  },
  {
    value: "444",
    name: "New Saeedabad",
    province_id: "5",
    province: "Sindh",
    district_id: "32",
    district: "Hyderabad",
  },
  {
    value: "445",
    name: "Nokundi",
    province_id: "1",
    province: "Balochistan",
    district_id: "14",
    district: "Chagai",
  },
  {
    value: "446",
    name: "Noor Pur Nauranga",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "447",
    name: "Nooriabad",
    province_id: "5",
    province: "Sindh",
    district_id: "36",
    district: "Jamshoro",
  },
  {
    value: "448",
    name: "Noorpur Thal",
    province_id: "4",
    province: "Punjab",
    district_id: "48",
    district: "Khushab",
  },
  {
    value: "449",
    name: "Nowhera Virkan",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "450",
    name: "Nowshera",
    province_id: "3",
    province: "KPK",
    district_id: "83",
    district: "Nowshera",
  },
  {
    value: "451",
    name: "Nurpur",
    province_id: "4",
    province: "Punjab",
    district_id: "48",
    district: "Khushab",
  },
  {
    value: "452",
    name: "Nushki",
    province_id: "1",
    province: "Balochistan",
    district_id: "84",
    district: "Nushki",
  },
  {
    value: "453",
    name: "Odero Lal",
    province_id: "5",
    province: "Sindh",
    district_id: "70",
    district: "Matiari",
  },
  {
    value: "454",
    name: "Oghi",
    province_id: "3",
    province: "KPK",
    district_id: "67",
    district: "Mansehra",
  },
  {
    value: "455",
    name: "Okara",
    province_id: "4",
    province: "Punjab",
    district_id: "85",
    district: "Okara",
  },
  {
    value: "456",
    name: "Ormara",
    province_id: "1",
    province: "Balochistan",
    district_id: "27",
    district: "Gwadar",
  },
  {
    value: "457",
    name: "Ornach",
    province_id: "1",
    province: "Balochistan",
    district_id: "49",
    district: "Khuzdar",
  },
  {
    value: "458",
    name: "Pabbi",
    province_id: "3",
    province: "KPK",
    district_id: "83",
    district: "Nowshera",
  },
  {
    value: "459",
    name: "Pacca Chang",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "460",
    name: "Padidan",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "461",
    name: "Pahar Pur",
    province_id: "3",
    province: "KPK",
    district_id: "22",
    district: "Dera Ismail Khan",
  },
  {
    value: "462",
    name: "Pakpattan",
    province_id: "4",
    province: "Punjab",
    district_id: "87",
    district: "Pakpattan",
  },
  {
    value: "463",
    name: "Palas",
    province_id: "3",
    province: "KPK",
    district_id: "54",
    district: "Kohistan",
  },
  {
    value: "464",
    name: "Panj Pai",
    province_id: "1",
    province: "Balochistan",
    district_id: "91",
    district: "Quetta",
  },
  {
    value: "465",
    name: "Panjgur",
    province_id: "1",
    province: "Balochistan",
    district_id: "88",
    district: "Panjgur",
  },
  {
    value: "466",
    name: "Panjmoro",
    province_id: "5",
    province: "Sindh",
    district_id: "80",
    district: "Nawabshah",
  },
  {
    value: "467",
    name: "Pano Aqil",
    province_id: "5",
    province: "Sindh",
    district_id: "105",
    district: "Sukkur",
  },
  {
    value: "468",
    name: "Parachinar",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "56",
    district: "Kurram Agency",
  },
  {
    value: "469",
    name: "Parome",
    province_id: "1",
    province: "Balochistan",
    district_id: "88",
    district: "Panjgur",
  },
  {
    value: "470",
    name: "Pasni",
    province_id: "1",
    province: "Balochistan",
    district_id: "27",
    district: "Gwadar",
  },
  {
    value: "471",
    name: "Pasrur",
    province_id: "4",
    province: "Punjab",
    district_id: "102",
    district: "Sialkot",
  },
  {
    value: "472",
    name: "Pattan",
    province_id: "3",
    province: "KPK",
    district_id: "54",
    district: "Kohistan",
  },
  {
    value: "473",
    name: "Pattoki",
    province_id: "4",
    province: "Punjab",
    district_id: "43",
    district: "Kasur",
  },
  {
    value: "474",
    name: "Perumal",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "475",
    name: "Peshawar",
    province_id: "3",
    province: "KPK",
    district_id: "89",
    district: "Peshawar",
  },
  {
    value: "476",
    name: "Phalia",
    province_id: "4",
    province: "Punjab",
    district_id: "66",
    district: "Mandi Bahauddin",
  },
  {
    value: "477",
    name: "Phelawagh",
    province_id: "1",
    province: "Balochistan",
    district_id: "20",
    district: "Dera Bughti",
  },
  {
    value: "478",
    name: "Phool Nagar",
    province_id: "4",
    province: "Punjab",
    district_id: "43",
    district: "Kasur",
  },
  {
    value: "479",
    name: "Phularwan",
    province_id: "4",
    province: "Punjab",
    district_id: "97",
    district: "Sargodha",
  },
  {
    value: "480",
    name: "Phulji",
    province_id: "5",
    province: "Sindh",
    district_id: "19",
    district: "Dadu",
  },
  {
    value: "481",
    name: "Pind Dadan Khan",
    province_id: "4",
    province: "Punjab",
    district_id: "39",
    district: "Jhelum",
  },
  {
    value: "482",
    name: "Pindi Bhattian",
    province_id: "4",
    province: "Punjab",
    district_id: "28",
    district: "Hafizabad",
  },
  {
    value: "483",
    name: "Pindi Gheb",
    province_id: "4",
    province: "Punjab",
    district_id: "2",
    district: "Attock",
  },
  {
    value: "484",
    name: "Pindiali",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "73",
    district: "Mohmand Agency",
  },
  {
    value: "485",
    name: "Piplan",
    province_id: "4",
    province: "Punjab",
    district_id: "71",
    district: "Mianwali",
  },
  {
    value: "486",
    name: "Pir Koh",
    province_id: "1",
    province: "Balochistan",
    district_id: "20",
    district: "Dera Bughti",
  },
  {
    value: "487",
    name: "Pir Mahal",
    province_id: "4",
    province: "Punjab",
    district_id: "112",
    district: "Toba Tek Singh",
  },
  {
    value: "488",
    name: "Pir Wasan",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "489",
    name: "Pirjo Goth",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "490",
    name: "Pirwasan",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "491",
    name: "Piryaloi",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "492",
    name: "Pishin",
    province_id: "1",
    province: "Balochistan",
    district_id: "90",
    district: "Pishin",
  },
  {
    value: "493",
    name: "Pithoro",
    province_id: "5",
    province: "Sindh",
    district_id: "113",
    district: "Umarkot",
  },
  {
    value: "494",
    name: "Pull Bagar",
    province_id: "4",
    province: "Punjab",
    district_id: "46",
    district: "Khanewal",
  },
  {
    value: "495",
    name: "Puran",
    province_id: "3",
    province: "KPK",
    district_id: "98",
    district: "Shangla",
  },
  {
    value: "496",
    name: "Qaboola",
    province_id: "4",
    province: "Punjab",
    district_id: "87",
    district: "Pakpattan",
  },
  {
    value: "497",
    name: "Qadirabad",
    province_id: "4",
    province: "Punjab",
    district_id: "66",
    district: "Mandi Bahauddin",
  },
  {
    value: "498",
    name: "Qadirpur Ran",
    province_id: "4",
    province: "Punjab",
    district_id: "74",
    district: "Multan",
  },
  {
    value: "499",
    name: "Qaimpur",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "500",
    name: "Qamar Din Karez",
    province_id: "1",
    province: "Balochistan",
    district_id: "116",
    district: "Zhob",
  },
  {
    value: "501",
    name: "Qasimabad",
    province_id: "5",
    province: "Sindh",
    district_id: "32",
    district: "Hyderabad",
  },
  {
    value: "502",
    name: "Qazi Ahmed",
    province_id: "5",
    province: "Sindh",
    district_id: "80",
    district: "Nawabshah",
  },
  {
    value: "503",
    name: "Qila Didar Singh",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "504",
    name: "Quaidabad",
    province_id: "4",
    province: "Punjab",
    district_id: "48",
    district: "Khushab",
  },
  {
    value: "505",
    name: "Quetta",
    province_id: "1",
    province: "Balochistan",
    district_id: "91",
    district: "Quetta",
  },
  {
    value: "506",
    name: "Qutabpur",
    province_id: "4",
    province: "Punjab",
    district_id: "62",
    district: "Lodhran",
  },
  {
    value: "507",
    name: "Radhan",
    province_id: "5",
    province: "Sindh",
    district_id: "19",
    district: "Dadu",
  },
  {
    value: "508",
    name: "Rahim Yar Khan",
    province_id: "4",
    province: "Punjab",
    district_id: "92",
    district: "Rahim Yar Khan",
  },
  {
    value: "509",
    name: "Rahuki",
    province_id: "5",
    province: "Sindh",
    district_id: "32",
    district: "Hyderabad",
  },
  {
    value: "510",
    name: "Raja Jang",
    province_id: "4",
    province: "Punjab",
    district_id: "43",
    district: "Kasur",
  },
  {
    value: "511",
    name: "Rajanpur",
    province_id: "4",
    province: "Punjab",
    district_id: "93",
    district: "Rajan Pur",
  },
  {
    value: "512",
    name: "Rajo Khanani",
    province_id: "5",
    province: "Sindh",
    district_id: "4",
    district: "Badin",
  },
  {
    value: "513",
    name: "Ranipur",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "514",
    name: "Rasoolabad",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "515",
    name: "Rasul Nagar",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "516",
    name: "Rato Dero",
    province_id: "5",
    province: "Sindh",
    district_id: "59",
    district: "Larkana",
  },
  {
    value: "517",
    name: "Rawalpindi",
    province_id: "4",
    province: "Punjab",
    district_id: "94",
    district: "Rawalpindi",
  },
  {
    value: "518",
    name: "Razmak",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "82",
    district: "North Waziristan",
  },
  {
    value: "519",
    name: "Renala Khurd",
    province_id: "4",
    province: "Punjab",
    district_id: "85",
    district: "Okara",
  },
  {
    value: "520",
    name: "Risalpur",
    province_id: "3",
    province: "KPK",
    district_id: "83",
    district: "Nowshera",
  },
  {
    value: "521",
    name: "Rohillanwali",
    province_id: "4",
    province: "Punjab",
    district_id: "76",
    district: "Muzaffargarh",
  },
  {
    value: "522",
    name: "Rohri",
    province_id: "5",
    province: "Sindh",
    district_id: "105",
    district: "Sukkur",
  },
  {
    value: "523",
    name: "Rojhan",
    province_id: "4",
    province: "Punjab",
    district_id: "93",
    district: "Rajan Pur",
  },
  {
    value: "524",
    name: "Rustam",
    province_id: "5",
    province: "Sindh",
    district_id: "101",
    district: "Shikarpur",
  },
  {
    value: "525",
    name: "Sadda",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "56",
    district: "Kurram Agency",
  },
  {
    value: "526",
    name: "Sadiqabad",
    province_id: "4",
    province: "Punjab",
    district_id: "92",
    district: "Rahim Yar Khan",
  },
  {
    value: "527",
    name: "Saeedabad",
    province_id: "5",
    province: "Sindh",
    district_id: "70",
    district: "Matiari",
  },
  {
    value: "528",
    name: "Safdarabad",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "529",
    name: "Safi",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "73",
    district: "Mohmand Agency",
  },
  {
    value: "530",
    name: "Sahiwal",
    province_id: "4",
    province: "Punjab",
    district_id: "95",
    district: "Sahiwal",
  },
  {
    value: "531",
    name: "Sakrand",
    province_id: "5",
    province: "Sindh",
    district_id: "80",
    district: "Nawabshah",
  },
  {
    value: "532",
    name: "Salarzai",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "7",
    district: "Bajaur Agency",
  },
  {
    value: "533",
    name: "Salehput",
    province_id: "5",
    province: "Sindh",
    district_id: "105",
    district: "Sukkur",
  },
  {
    value: "534",
    name: "Sam Ranizai",
    province_id: "3",
    province: "KPK",
    district_id: "13",
    district: "Buner",
  },
  {
    value: "535",
    name: "Samaro",
    province_id: "5",
    province: "Sindh",
    district_id: "72",
    district: "Mirpur Khas",
  },
  {
    value: "536",
    name: "Samasatta",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "537",
    name: "Sambrial",
    province_id: "4",
    province: "Punjab",
    district_id: "102",
    district: "Sialkot",
  },
  {
    value: "538",
    name: "Samundari",
    province_id: "4",
    province: "Punjab",
    district_id: "23",
    district: "Faisalabad",
  },
  {
    value: "539",
    name: "Sangan",
    province_id: "1",
    province: "Balochistan",
    district_id: "103",
    district: "Sibi",
  },
  {
    value: "540",
    name: "Sanghar",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "541",
    name: "Sangla Hill",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "542",
    name: "Sanjwal Cantt.",
    province_id: "4",
    province: "Punjab",
    district_id: "2",
    district: "Attock",
  },
  {
    value: "543",
    name: "Sanni",
    province_id: "1",
    province: "Balochistan",
    district_id: "12",
    district: "Bolan (Dhadar)",
  },
  {
    value: "544",
    name: "Sarai Alamgir",
    province_id: "4",
    province: "Punjab",
    district_id: "26",
    district: "Gujrat",
  },
  {
    value: "545",
    name: "Sarai Naurang",
    province_id: "3",
    province: "KPK",
    district_id: "58",
    district: "Lakki Marwat",
  },
  {
    value: "546",
    name: "Sarai Sidhu",
    province_id: "4",
    province: "Punjab",
    district_id: "46",
    district: "Khanewal",
  },
  {
    value: "547",
    name: "Sararogha",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "104",
    district: "South Waziristan",
  },
  {
    value: "548",
    name: "Sargodha",
    province_id: "4",
    province: "Punjab",
    district_id: "97",
    district: "Sargodha",
  },
  {
    value: "549",
    name: "Sarhad",
    province_id: "5",
    province: "Sindh",
    district_id: "24",
    district: "Ghotki",
  },
  {
    value: "550",
    name: "Sarhari",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "551",
    name: "Sarwakai",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "104",
    district: "South Waziristan",
  },
  {
    value: "552",
    name: "Sehwan",
    province_id: "5",
    province: "Sindh",
    district_id: "19",
    district: "Dadu",
  },
  {
    value: "553",
    name: "Setharja",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "554",
    name: "Shabqadar",
    province_id: "3",
    province: "KPK",
    district_id: "16",
    district: "Charsadda",
  },
  {
    value: "555",
    name: "Shadan Lund",
    province_id: "4",
    province: "Punjab",
    district_id: "21",
    district: "Dera Ghazi Khan",
  },
  {
    value: "556",
    name: "Shadiwal",
    province_id: "4",
    province: "Punjab",
    district_id: "26",
    district: "Gujrat",
  },
  {
    value: "557",
    name: "Shah Bander",
    province_id: "5",
    province: "Sindh",
    district_id: "111",
    district: "Thatta",
  },
  {
    value: "558",
    name: "Shah Jamal",
    province_id: "4",
    province: "Punjab",
    district_id: "76",
    district: "Muzaffargarh",
  },
  {
    value: "559",
    name: "Shah Jeewna",
    province_id: "4",
    province: "Punjab",
    district_id: "38",
    district: "Jhang",
  },
  {
    value: "560",
    name: "Shahdadkot",
    province_id: "5",
    province: "Sindh",
    district_id: "59",
    district: "Larkana",
  },
  {
    value: "561",
    name: "Shahdadpur",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "562",
    name: "Shaher Sultan",
    province_id: "4",
    province: "Punjab",
    district_id: "76",
    district: "Muzaffargarh",
  },
  {
    value: "563",
    name: "Shahpur",
    province_id: "4",
    province: "Punjab",
    district_id: "97",
    district: "Sargodha",
  },
  {
    value: "564",
    name: "Shahpur Chakar",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "565",
    name: "Shahpur Jahania",
    province_id: "5",
    province: "Sindh",
    district_id: "80",
    district: "Nawabshah",
  },
  {
    value: "566",
    name: "Shahpur Saddar",
    province_id: "4",
    province: "Punjab",
    district_id: "97",
    district: "Sargodha",
  },
  {
    value: "567",
    name: "Shakardara",
    province_id: "3",
    province: "KPK",
    district_id: "53",
    district: "Kohat",
  },
  {
    value: "568",
    name: "Shakargarh",
    province_id: "4",
    province: "Punjab",
    district_id: "77",
    district: "Narowal",
  },
  {
    value: "569",
    name: "Shangla",
    province_id: "3",
    province: "KPK",
    district_id: "98",
    district: "Shangla",
  },
  {
    value: "570",
    name: "Sharqpur",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "571",
    name: "Sheikhupura",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "572",
    name: "Sherani",
    province_id: "1",
    province: "Balochistan",
    district_id: "100",
    district: "Sherani",
  },
  {
    value: "573",
    name: "Shewa",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "82",
    district: "North Waziristan",
  },
  {
    value: "574",
    name: "Shikarpur",
    province_id: "5",
    province: "Sindh",
    district_id: "101",
    district: "Shikarpur",
  },
  {
    value: "575",
    name: "Shorkot",
    province_id: "4",
    province: "Punjab",
    district_id: "38",
    district: "Jhang",
  },
  {
    value: "576",
    name: "Shujabad",
    province_id: "4",
    province: "Punjab",
    district_id: "74",
    district: "Multan",
  },
  {
    value: "577",
    name: "Sialkot",
    province_id: "4",
    province: "Punjab",
    district_id: "102",
    district: "Sialkot",
  },
  {
    value: "578",
    name: "Sibi",
    province_id: "1",
    province: "Balochistan",
    district_id: "103",
    district: "Sibi",
  },
  {
    value: "579",
    name: "Sillanwali",
    province_id: "4",
    province: "Punjab",
    district_id: "97",
    district: "Sargodha",
  },
  {
    value: "580",
    name: "Sinjawi",
    province_id: "1",
    province: "Balochistan",
    district_id: "117",
    district: "Ziarat",
  },
  {
    value: "581",
    name: "Sinjhoro",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "582",
    name: "Sobhodero",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "583",
    name: "Sodhra",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "584",
    name: "Sohawa",
    province_id: "4",
    province: "Punjab",
    district_id: "39",
    district: "Jhelum",
  },
  {
    value: "585",
    name: "Sohbatpur",
    province_id: "1",
    province: "Balochistan",
    district_id: "35",
    district: "Jaffarabad",
  },
  {
    value: "586",
    name: "Spinwam",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "82",
    district: "North Waziristan",
  },
  {
    value: "587",
    name: "Sui",
    province_id: "1",
    province: "Balochistan",
    district_id: "20",
    district: "Dera Bughti",
  },
  {
    value: "588",
    name: "SUI",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "589",
    name: "Sujawal",
    province_id: "5",
    province: "Sindh",
    district_id: "111",
    district: "Thatta",
  },
  {
    value: "590",
    name: "Sukheke",
    province_id: "4",
    province: "Punjab",
    district_id: "28",
    district: "Hafizabad",
  },
  {
    value: "591",
    name: "Sukkur",
    province_id: "5",
    province: "Sindh",
    district_id: "105",
    district: "Sukkur",
  },
  {
    value: "592",
    name: "Sultanabad",
    province_id: "5",
    province: "Sindh",
    district_id: "72",
    district: "Mirpur Khas",
  },
  {
    value: "593",
    name: "Surab",
    province_id: "1",
    province: "Balochistan",
    district_id: "40",
    district: "Kalat",
  },
  {
    value: "594",
    name: "Swabi",
    province_id: "3",
    province: "KPK",
    district_id: "106",
    district: "Swabi",
  },
  {
    value: "595",
    name: "Swat",
    province_id: "3",
    province: "KPK",
    district_id: "107",
    district: "Swat",
  },
  {
    value: "596",
    name: "Taftan",
    province_id: "1",
    province: "Balochistan",
    district_id: "14",
    district: "Chagai",
  },
  {
    value: "597",
    name: "Takht Bhai",
    province_id: "3",
    province: "KPK",
    district_id: "68",
    district: "Mardan",
  },
  {
    value: "598",
    name: "Takht Mahal",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "599",
    name: "Takht-e-Nasriti",
    province_id: "3",
    province: "KPK",
    district_id: "42",
    district: "Karak",
  },
  {
    value: "600",
    name: "Talagang",
    province_id: "4",
    province: "Punjab",
    district_id: "15",
    district: "Chakwal",
  },
  {
    value: "601",
    name: "Talhar",
    province_id: "5",
    province: "Sindh",
    district_id: "4",
    district: "Badin",
  },
  {
    value: "602",
    name: "Tall",
    province_id: "3",
    province: "KPK",
    district_id: "29",
    district: "Hangu",
  },
  {
    value: "603",
    name: "Tamboo",
    province_id: "1",
    province: "Balochistan",
    district_id: "78",
    district: "Nasirabad",
  },
  {
    value: "604",
    name: "Tandlianwala",
    province_id: "4",
    province: "Punjab",
    district_id: "23",
    district: "Faisalabad",
  },
  {
    value: "605",
    name: "Tando Adam Khan",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "606",
    name: "Tando Allahyar",
    province_id: "5",
    province: "Sindh",
    district_id: "32",
    district: "Hyderabad",
  },
  {
    value: "607",
    name: "Tando Bagho",
    province_id: "5",
    province: "Sindh",
    district_id: "4",
    district: "Badin",
  },
  {
    value: "608",
    name: "Tando Ghulam Ali",
    province_id: "5",
    province: "Sindh",
    district_id: "108",
    district: "Tando Muhammad Khan",
  },
  {
    value: "609",
    name: "Tando Ghulam Muhammad",
    province_id: "5",
    province: "Sindh",
    district_id: "108",
    district: "Tando Muhammad Khan",
  },
  {
    value: "610",
    name: "Tando Jam",
    province_id: "5",
    province: "Sindh",
    district_id: "32",
    district: "Hyderabad",
  },
  {
    value: "611",
    name: "Tando Jan Muhammad",
    province_id: "5",
    province: "Sindh",
    district_id: "72",
    district: "Mirpur Khas",
  },
  {
    value: "612",
    name: "Tando Mitha Khan",
    province_id: "5",
    province: "Sindh",
    district_id: "96",
    district: "Sanghar",
  },
  {
    value: "613",
    name: "Tando Muhammad Khan",
    province_id: "5",
    province: "Sindh",
    district_id: "108",
    district: "Tando Muhammad Khan",
  },
  {
    value: "614",
    name: "Tangi",
    province_id: "3",
    province: "KPK",
    district_id: "16",
    district: "Charsadda",
  },
  {
    value: "615",
    name: "Tangwani",
    province_id: "5",
    province: "Sindh",
    district_id: "34",
    district: "Jacobabad",
  },
  {
    value: "616",
    name: "Tank",
    province_id: "3",
    province: "KPK",
    district_id: "109",
    district: "Tank",
  },
  {
    value: "617",
    name: "Tatepur",
    province_id: "4",
    province: "Punjab",
    district_id: "74",
    district: "Multan",
  },
  {
    value: "618",
    name: "Taunsa sharif",
    province_id: "4",
    province: "Punjab",
    district_id: "21",
    district: "Dera Ghazi Khan",
  },
  {
    value: "619",
    name: "Taxila",
    province_id: "4",
    province: "Punjab",
    district_id: "94",
    district: "Rawalpindi",
  },
  {
    value: "620",
    name: "Thano Bula Khan",
    province_id: "5",
    province: "Sindh",
    district_id: "19",
    district: "Dadu",
  },
  {
    value: "621",
    name: "Thari Mirwah",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "622",
    name: "Tharu Shah",
    province_id: "5",
    province: "Sindh",
    district_id: "79",
    district: "Naushro Feroze",
  },
  {
    value: "623",
    name: "Thatta",
    province_id: "5",
    province: "Sindh",
    district_id: "111",
    district: "Thatta",
  },
  {
    value: "624",
    name: "Thengmore",
    province_id: "4",
    province: "Punjab",
    district_id: "43",
    district: "Kasur",
  },
  {
    value: "625",
    name: "Theri",
    province_id: "5",
    province: "Sindh",
    district_id: "45",
    district: "Khairpur",
  },
  {
    value: "626",
    name: "Thul",
    province_id: "5",
    province: "Sindh",
    district_id: "34",
    district: "Jacobabad",
  },
  {
    value: "627",
    name: "Tiarza",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "104",
    district: "South Waziristan",
  },
  {
    value: "628",
    name: "Tibba Sultanpur",
    province_id: "4",
    province: "Punjab",
    district_id: "115",
    district: "Vehari",
  },
  {
    value: "629",
    name: "Timargara",
    province_id: "3",
    province: "KPK",
    district_id: "64",
    district: "Lower Dir",
  },
  {
    value: "630",
    name: "Tobe Tek Singh",
    province_id: "4",
    province: "Punjab",
    district_id: "112",
    district: "Toba Tek Singh",
  },
  {
    value: "631",
    name: "Toi Khullah",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "104",
    district: "South Waziristan",
  },
  {
    value: "632",
    name: "Topi",
    province_id: "3",
    province: "KPK",
    district_id: "106",
    district: "Swabi",
  },
  {
    value: "633",
    name: "Tordher",
    province_id: "3",
    province: "KPK",
    district_id: "106",
    district: "Swabi",
  },
  {
    value: "634",
    name: "Tulamba",
    province_id: "4",
    province: "Punjab",
    district_id: "46",
    district: "Khanewal",
  },
  {
    value: "635",
    name: "Tump",
    province_id: "1",
    province: "Balochistan",
    district_id: "44",
    district: "Kech(Turbat)",
  },
  {
    value: "636",
    name: "Turbat",
    province_id: "1",
    province: "Balochistan",
    district_id: "44",
    district: "Kech(Turbat)",
  },
  {
    value: "637",
    name: "Ubauro",
    province_id: "5",
    province: "Sindh",
    district_id: "24",
    district: "Ghotki",
  },
  {
    value: "638",
    name: "Uch Sharif",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "639",
    name: "Umarkot",
    province_id: "5",
    province: "Sindh",
    district_id: "113",
    district: "Umarkot",
  },
  {
    value: "640",
    name: "Upper Kurram",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "56",
    district: "Kurram Agency",
  },
  {
    value: "641",
    name: "Upper Mohmand",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "73",
    district: "Mohmand Agency",
  },
  {
    value: "642",
    name: "Usta Muhammad",
    province_id: "1",
    province: "Balochistan",
    district_id: "35",
    district: "Jaffarabad",
  },
  {
    value: "643",
    name: "Uthal",
    province_id: "1",
    province: "Balochistan",
    district_id: "60",
    district: "Lasbella",
  },
  {
    value: "644",
    name: "Utmanzai",
    province_id: "3",
    province: "KPK",
    district_id: "16",
    district: "Charsadda",
  },
  {
    value: "645",
    name: "Vehari",
    province_id: "4",
    province: "Punjab",
    district_id: "115",
    district: "Vehari",
  },
  {
    value: "646",
    name: "Wadh",
    province_id: "1",
    province: "Balochistan",
    district_id: "49",
    district: "Khuzdar",
  },
  {
    value: "647",
    name: "Wana",
    province_id: "2",
    province: "F.A.T.A",
    district_id: "104",
    district: "South Waziristan",
  },
  {
    value: "648",
    name: "Warah",
    province_id: "5",
    province: "Sindh",
    district_id: "59",
    district: "Larkana",
  },
  {
    value: "649",
    name: "Warburton",
    province_id: "4",
    province: "Punjab",
    district_id: "99",
    district: "Sheikhupura",
  },
  {
    value: "650",
    name: "Wari",
    province_id: "3",
    province: "KPK",
    district_id: "114",
    district: "Upper Dir",
  },
  {
    value: "651",
    name: "Washuk",
    province_id: "1",
    province: "Balochistan",
    district_id: "47",
    district: "Kharan",
  },
  {
    value: "652",
    name: "Wazirabad",
    province_id: "4",
    province: "Punjab",
    district_id: "25",
    district: "Gujranwala",
  },
  {
    value: "653",
    name: "Winder",
    province_id: "1",
    province: "Balochistan",
    district_id: "60",
    district: "Lasbella",
  },
  {
    value: "654",
    name: "Yazman Mandi",
    province_id: "4",
    province: "Punjab",
    district_id: "6",
    district: "Bahawalpur",
  },
  {
    value: "655",
    name: "Zafarwal",
    province_id: "4",
    province: "Punjab",
    district_id: "77",
    district: "Narowal",
  },
  {
    value: "656",
    name: "Zahirpir",
    province_id: "4",
    province: "Punjab",
    district_id: "92",
    district: "Rahim Yar Khan",
  },
  {
    value: "657",
    name: "Zaida",
    province_id: "3",
    province: "KPK",
    district_id: "106",
    district: "Swabi",
  },
  {
    value: "658",
    name: "Zehri",
    province_id: "1",
    province: "Balochistan",
    district_id: "49",
    district: "Khuzdar",
  },
  {
    value: "659",
    name: "Zhob",
    province_id: "1",
    province: "Balochistan",
    district_id: "116",
    district: "Zhob",
  },
  {
    value: "660",
    name: "Ziarat",
    province_id: "1",
    province: "Balochistan",
    district_id: "117",
    district: "Ziarat",
  },
];

export const reportsName = [
  {
    value: "Daily Prices",
    name: "Daily Prices",
  },
  {
    value: "PAR News Bulletin",
    name: "PAR News Bulletin",
  },
  {
    value: "Weekly Water & Weather Report",
    name: "Weekly Water & Weather Report",
  },
  {
    value: "Sugarcane Crushing",
    name: "Sugarcane Crushing",
  },
  {
    value: "PCGA Arrivals Data Analysis",
    name: "PCGA Arrivals Data Analysis",
  },
  {
    value: "Crop Survey Reports",
    name: "Crop Survey Reports",
  },
  {
    value: "Monthly Import/Export",
    name: "Monthly Import/Export",
  },
  {
    value: "Annual Balance Sheet",
    name: "Annual Balance Sheet",
  },
  {
    value: "Annual Cost of Production",
    name: "Annual Cost of Production",
  },
];

export const commodities = [
  {
    commodity: "cotton",
    reportsType: [
      "Daily Prices",
      "PAR News Bulletin",
      "Water & Weather Reports",
      "PCGA Arrivals Data Analysis",
      "Crop Survey Reports",
      "Monthly Import/Export",
      "Annual Balance Sheet",
      "Annual Cost of Production",
    ],
  },
  {
    commodity: "sugar",
    reportsType: [
      "Daily Prices",
      "PAR News Bulletin",
      "Water & Weather Reports",
      "Sugarcane Crushing",
      "Crop Survey Reports",
      "Monthly Import/Export",
      "Annual Balance Sheet",
      "Annual Cost of Production",
    ],
  },
  {
    commodity: "wheat",
    reportsType: [
      "Daily Prices",
      "PAR News Bulletin",
      "Water & Weather Reports",
      "Crop Survey Reports",
      "Monthly Import/Export",
      "Annual Balance Sheet",
      "Annual Cost of Production",
    ],
  },
  {
    commodity: "maize",
    reportsType: [
      "Daily Prices",
      "PAR News Bulletin",
      "Weekly Water Reports",
      "Crop Survey Reports",
      "Monthly Export",
      "Annual Balance Sheet",
      "Annual Cost of Production",
    ],
  },
  {
    commodity: "rice",
    reportsType: [
      "Daily Prices",
      "PAR News Bulletin",
      "Weekly Water Report",
      "Crop Survey Reports",
      "Monthly Export",
      "Annual Balance Sheet",
      "Annual Cost of Production",
    ],
  },
  {
    commodity: "spices",
    reportsType: [
      "Daily Prices",
      "PAR News Bulletin",
      "Water and Weather Reports",
      "Monthly Import/Export",
    ],
  },
  {
    commodity: "edible oil",
    reportsType: [
      "Daily Prices",
      "PAR News Bulletin",
      "Water and Weather Reports",
      "Monthly Import",
    ],
  },
  {
    commodity: "pulses",
    reportsType: [
      "Daily Prices",
      "PAR News Bulletin",
      "Water and Weather Reports",
      "Monthly Import",
    ],
  },
];
